"use strict";
// On Scroll Loading
 
$.fn.loadOnScroll = function( options ) {

    if(!this.length){
        return
    }

    const self = this
    var config = $.extend({
        skeletonLoader: 'skeleton-loader',
        loader: true,
        delay: 0,
        api: false,
        threshold: 100
    }, options );

    if(!this.hasClass(config.skeletonLoader) && config.loader){
        this.addClass(config.skeletonLoader)
    }

    const callBack = function(){
        
        if ($(window).scrollTop() >= config.threshold) {
            
            if(config.api){
                const sectionId = config.section_id
                window.setTimeout(() => {
                    fetch(window.Shopify.routes.root + "?sections="+sectionId)
                    .then(res => res.json())
                    .then(data => {
                        self.html(data[sectionId])
                        self.removeClass(config.skeletonLoader)
                    });
                }, config.delay)
            }else{
                window.setTimeout(() => {
                    self.removeClass(config.skeletonLoader)
                    eval(config.script + "()");
                }, config.delay)
            }

            $(window).off('scroll', callBack);
            
        }
    } 

    $(window).on('scroll', callBack);
}

// End On Scroll Loading
function AjaxCollection(t, e) {
    (this.handle = t),
        (this.productsByHandle = {}),
        (this.productsByID = {}),
        (this.products = []),
        (this.container = e),
        (this.productHandlers = []),
        (this.collectionHandlers = []),
        (this.filterListeners = []),
        (this.processingRequests = []),
        (this.nextRequestID = 0),
        (this.f = { sort: AjaxCollection.constants.sort.Page });
}
function WanderersCollectionPage(t, e) {
    AjaxCollection.call(this, t, e), (this.perPage = 16), $("body").on("touchmove", this.onScroll.bind(this)), $(window).scroll(this.onScroll.bind(this));
}
function changeFreeGiftThumb() {
    $('#free-barca select[name="id"]').on("change", function () {
        $(this).attr("data-product-id");
        var t = $(this).attr("data-target"),
            e = $(this).find("option:selected").attr("data-image");
        $(t).find("img").attr("src", e);
    });
}
function changeCTAMothersDay(addToCartbtn){
    Shopify.getCart(function (cart) {
        var total_price = 0, has_free_gwp = false, CURRENT_PRODUCT = window.CURRENT_PRODUCT;
        $(cart.items).each(function (idx, cart_item) {
            if (cart_item.product_type != "Gift Certificate") {
                total_price = total_price + cart_item.line_price;
            }
            if (cart_item.line_price == 0 ) {
                has_free_gwp = true;
            }
        });
        let btn_text = theme.strings.addToCart;
        if (total_price >= 40000 && !has_free_gwp && CURRENT_PRODUCT.tags.indexOf('gift-3') !== -1) {
            btn_text = 'GET IT FOR FREE'
        }
        addToCartbtn.find('[data-add-to-cart-text]').text(btn_text)
    });
}
function updateLowStock() {
    $("[data-lowstock]").each(function (t, e) {
        var o = $(this),
            a = Shopify.inventory_map,
            n = $('select[name="id"]').find("option:selected").attr("value");
        if (n) {
            var i = a[n];
            if (i < 0) return o.removeClass("is-visible"), !0;
            0 == i || i > 20 ? o.removeClass("is-visible") : o.addClass("is-visible");
        }
    });
}
"undefined" == typeof Shopify && (Shopify = {}),
    (Shopify.getCart = function (t) {
        jQuery.getJSON("/cart.js", function (e, o) {
            if ("function" == typeof t) t(e);
            else if (Array.isArray(t)) for (i = 0; i < t.length; i++) "function" == typeof t[i] && t[i](e);
            else "function" == typeof Shopify.onCartUpdate && Shopify.onCartUpdate(e);
        });
    }),
    (Shopify.getCartHtml = function (t) {
        jQuery.ajax({ url: "/cart", type: "get", dataType: "html", success: t });
    }),
    (window.slate = window.slate || {}),
    (window.theme = window.theme || {}),
    (Shopify.GWP = "#shopify-section-free-gift-promo"),
    (Shopify.free_barca = "#shopify-section-free-barca"),
    (slate.a11y = {
        pageLinkFocus: function (t) {
            var e = "js-focus-hidden";
            t.first()
                .attr("tabIndex", "-1")
                .focus()
                .addClass(e)
                .one("blur", function () {
                    t.first().removeClass(e).removeAttr("tabindex");
                });
        },
        focusHash: function () {
            var t = window.location.hash;
            t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t));
        },
        bindInPageLinks: function () {
            $("a[href*=#]").on(
                "click",
                function (t) {
                    this.pageLinkFocus($(t.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$elementToFocus || (t.$elementToFocus = t.$container),
                t.$container.attr("tabindex", "-1"),
                t.$elementToFocus.focus(),
                $(document).on(e, function (e) {
                    t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus();
                });
        },
        removeTrapFocus: function (t) {
            var e = t.namespace ? "focusin." + t.namespace : "focusin";
            t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document).off(e);
        },
    }),
    (slate.cart = {
        cookiesEnabled: function () {
            var t = navigator.cookieEnabled;
            return t || ((document.cookie = "testcookie"), (t = -1 !== document.cookie.indexOf("testcookie"))), t;
        },
    }),
    (Shopify.AjaxifyCart = (function ($) {
        var _config = {
            addToCartBtnLabel: "Add to cart",
            addedToCartBtnLabel: "Thank you!",
            addingToCartBtnLabel: "Adding...",
            soldOutBtnLabel: "Sold Out",
            preorderBtnLabel: theme.strings.preorderButton,
            howLongTillBtnReturnsToNormal: 1e3,
            cartCountSelector: ".site-nav__cart__count, .cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count",
            cartTotalSelector: "#cart-price,.cart__total",
            feedbackPosition: "nextButton",
            addToCartBtnSelector: '[type="submit"]',
            addToCartFormSelector: 'form[action="/cart/add"]:not(.free-barca)',
            shopifyAjaxAddURL: "/cart/add.js",
            shopifyAjaxCartURL: "/cart.js",
        },
            _showFeedback = function (t, e, o) {
                $(".ajaxified-cart-feedback").remove();
                var a = '<p class="ajaxified-cart-feedback ' + t + '">' + e + "</p>";
                switch (_config.feedbackPosition) {
                    case "aboveForm":
                        o.before(a);
                        break;
                    case "belowForm":
                        o.after(a);
                        break;
                    case "nextButton":
                    default:
                        o.find(_config.addToCartBtnSelector).after(a);
                }
                $(".ajaxified-cart-feedback").slideDown();
            },
            defaultOption = function (t, e) {
                return void 0 === t ? e : t;
            },
            formatWithDelimiters = function (t, e, o, a) {
                if (((e = defaultOption(e, 2)), (o = defaultOption(o, ",")), (a = defaultOption(a, ".")), isNaN(t) || null == t)) return 0;
                var n = (t = (t / 100).toFixed(e)).split(".");
                return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (n[1] ? a + n[1] : "");
            },
            _setText = function (t, e) {
                t.children().length
                    ? t.children().each(function () {
                        "" !== $.trim($(this).text()) && $(this).text(e);
                    })
                    : t.val(e).text(e);
            },
            afterAddToCart = function (t, e,current_button) {
                let productJson = $("[data-product-json]").html()
                let compareAtPrice = 0
                if(productJson){
                    productJson = JSON.parse(productJson)
                    compareAtPrice = productJson.compare_at_price
                }
                var afterAddToCartButton = e;
                _setText(e, _config.addingToCartBtnLabel), e.addClass("disabled").prop("disabled", !0);
                var o = $(window).width(),
                    a =`<table>    <tbody>    <tr>    <td>    <a href="${t.url}">    <img src="${t.image}" alt="${t.title}">    </a>    </td>    <td class="item-content">    <a href="${t.url}">    <h4 class="item-title" >${t.name || t.title}</h4>    </a>    <div class="cart__item-subtotal index-1">    <span ${compareAtPrice && compareAtPrice > t.price ? 'class="sale-final-price"' : ''} data-currency="" data-money="${t.price}">${moneyFormat(t.price)}</span>\t${compareAtPrice && compareAtPrice > t.price ? '<s data-currency="" data-money="' + compareAtPrice + '">' + moneyFormat(compareAtPrice) + "</s>" : ""}    </div>    </td>    </tr>    </tbody>    </table>`;
                    e.addClass("inverted");
                    $("#cart-modal-item").html(a),
                    o < 415
                        ? ($(".cart-modal").show("slow").animate({ top: "0px" }, "slow"),
                            $(".product__image-wrapper__thumbs").addClass("cart-open"),
                            setTimeout(function () {
                                $(".cart-modal").animate({ top: "-500px" }, "slow").hide("slow");
                            }, 5e3),
                            setTimeout(function () {
                                $(".product__image-wrapper__thumbs").removeClass("cart-open");
                            }, 5500))
                        : o >= 415 && o < 850
                            ? ($(".cart-modal").show("slow").animate({ right: "0px" }, "slow"),
                                $(".product__image-wrapper__thumbs").addClass("cart-open"),
                                setTimeout(function () {
                                    $(".cart-modal").animate({ right: "-500px" }, "slow").hide("slow");
                                }, 5e3),
                                setTimeout(function () {
                                    $(".product__image-wrapper__thumbs").removeClass("cart-open");
                                }, 5500))
                            : o >= 850 && $("#cart-toggle").trigger("click");

                    setTimeout(function () {
                        _setText(e, _config.addedToCartBtnLabel);
                        if(current_button) $(current_button).removeClass('pseudo-loading');
                    }, 1050);

                    window.setTimeout(function () {
                        e.prop("disabled", !1).removeClass("disabled").removeClass("inverted"),
                        (e.hasClass('btn--preorder'))?
                            _setText(e, _config.preorderBtnLabel)
                        :   _setText(e, _config.addToCartBtnLabel);
                    }, _config.howLongTillBtnReturnsToNormal + 1e3);

                    Shopify.getCart(function (t) {
                        $(_config.addToCartFormSelector).find("#prop-free-gift").remove();
                        var total_price = 0, has_free_gwp = false, CURRENT_PRODUCT = window.CURRENT_PRODUCT;
                        
                        $(t.items).each(function (t, e) {
                            if (e.product_type != "Gift Certificate") {
                                total_price = total_price + e.line_price;
                            }
                            if (e.line_price == 0 ) {
                                has_free_gwp = true;
                            }
                            if (isFree(e.properties)) return $(_config.addToCartFormSelector).find("#prop-free-gift").remove(), !1;
                        });
                        window.setTimeout(function () {
                            afterAddToCartButton.prop("disabled", !1).removeClass("disabled").removeClass("inverted");
                            if (total_price >= 40000 && !has_free_gwp && CURRENT_PRODUCT.tags.indexOf('gift-3') !== -1) {
                                _setText(afterAddToCartButton, 'GET IT FOR FREE')
                            } else {
                                _setText(afterAddToCartButton, _config.addToCartBtnLabel)
                            }
                        }, _config.howLongTillBtnReturnsToNormal + 1e3);

                        var e = $(".c-cart-shipping-promo");
                        if (e.length && Shopify.GWP_PROMO) {
                            var tier_two_high_price =   window.promotiers.highestPrice[0]['tier2'];
                            var tier_three_high_price =   window.promotiers.highestPrice[0]['tier3'];
                            var __ids = window.promotiers.tier3;
                            if ($.inArray(CURRENT_PRODUCT.id, __ids) !== -1) {
                                e.html(
                                    `GET THIS ITEM FOR FREE WITH ORDERS OVER <span data-gwp-price data-currency data-money="40000">${moneyFormat(4e4)}</span>!`
                                );
                                if (total_price >= 40000 && !has_free_gwp) {
                                    $(_config.addToCartFormSelector).append('<input type="hidden" name="properties[_free]" value="1" id="prop-free-gift" />');
                                }
                            } else {
                                if (total_price < 2e4) {
                                    e.html(
                                        'SPEND OVER <span data-currency data-gwp-price data-money="20000">' +
                                        moneyFormat(2e4) +
                                        '</span> TO CHOOSE A FREE ELIGIBLE Clutch or WALLET (worth up to <span data-tier2 data-currency data-gwp-price data-money="' + tier_two_high_price + '">' +
                                        moneyFormat(tier_two_high_price) + "</span>)."
                                    );
                                } else {
                                    e.html(
                                        'SPEND OVER <span data-currency data-gwp-price data-money="40000">' +
                                        moneyFormat(4e4) +
                                        '</span> TO CHOOSE a FREE eligible crossbody, wallet OR SUNGLASSES (worth up to <span data-tier3 data-currency data-gwp-price data-money="' + tier_three_high_price + '">' +
                                        moneyFormat(tier_three) +
                                         "</span>)."
                                         );
                                }
                            }
                        }
                        Shopify.cart_items = window.items = t.items;
                        window.Currency.updatePrices();

                        var a = t.item_count > 0 ? "true" : "false";
                        if (_config.cartCountSelector && $(_config.cartCountSelector).size()) {
                            var n = $(_config.cartCountSelector).html() || "0";
                            $(_config.cartCountSelector)
                                .attr("data-show", a)
                                .html(n.replace(/[0-9]+/, t.item_count))
                                .removeClass("hidden-count");
                        }
                        if (_config.cartTotalSelector && $(_config.cartTotalSelector).size())
                            if ("undefined" != typeof Currency && void 0 !== Currency.moneyFormats) {
                                var i = "";
                                $('[name="currencies"]').size()
                                    ? (i = $('[name="currencies"]').val())
                                    : $("#currencies span.selected").size() && (i = $("#currencies span.selected").attr("data-currency")),
                                    i
                                        ? $(_config.cartTotalSelector).html("<span class=money>" + Shopify.formatMoney(Currency.convert(t.total_price, Currency.currency, i), Currency.money_format[i]) + "</span>")
                                        : $(_config.cartTotalSelector).html(moneyFormat(t.total_price));
                            } else $(_config.cartTotalSelector).html(moneyFormat(t.total_price));
                        o > 849 && refreshCartContent(t);
                    });
            },
            _init = function () {
                $(document).ready(function () {
                    $(_config.addToCartFormSelector).submit(function (e$jscomp$22) {
                        e$jscomp$22.preventDefault();
                        var $addToCartForm = $(this),
                            $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
                        return (
                            $.ajax({
                                url: _config.shopifyAjaxAddURL,
                                dataType: "json",
                                type: "post",
                                data: $addToCartForm.serialize(),
                                success: function (t) {
                                    afterAddToCart(t, $addToCartBtn);
                                },
                                error: function (XMLHttpRequest$jscomp$1) {
                                    var response$jscomp$2 = eval("(" + XMLHttpRequest$jscomp$1.responseText + ")");
                                    (response$jscomp$2 = response$jscomp$2.description),
                                        "All " === response$jscomp$2.slice(0, 4)
                                            ? (_showFeedback("error", response$jscomp$2.replace("All 1 ", "All "), $addToCartForm),
                                                $addToCartBtn.prop("disabled", !1),
                                                _setText($addToCartBtn, _config.soldOutBtnLabel),
                                                $addToCartBtn.prop("disabled", !0))
                                            : (_showFeedback("error", '<i class="fa fa-warning"></i> ' + response$jscomp$2, $addToCartForm),
                                                $addToCartBtn.prop("disabled", !1).removeClass("disabled"),
                                                _setText($addToCartBtn, _config.addToCartBtnLabel));
                                },
                            }),
                            !1
                        );
                    });
                    var width$jscomp$12 = $(window).width();
                    $(".top-cart__close").click(function () {
                        width$jscomp$12 < 415
                            ? $(this).parents(".cart-modal").animate({ top: "-500px" }, "slow").hide("slow")
                            : width$jscomp$12 >= 415 && width$jscomp$12 < 850 && $(this).parents(".cart-modal").animate({ right: "-500px" }, "slow").hide("slow");
                    });
                });
            };
        return {
            init: function (t) {
                (t = t || {}),
                    $.extend(_config, t),
                    $(function () {
                        _init();
                    });
            },
            getConfig: function () {
                return _config;
            },
            afterAddToCart: function (t, e,current_button=null) {
                afterAddToCart(t, e,current_button);
            },
        };
    })(jQuery)),
    Shopify.AjaxifyCart.init(),
    (slate.utils = {
        findInstance: function (t, e, o) {
            for (var a = 0; a < t.length; a++) if (t[a][e] === o) return t[a];
        },
        removeInstance: function (t, e, o) {
            for (var a = t.length; a--;)
                if (t[a][e] === o) {
                    t.splice(a, 1);
                    break;
                }
            return t;
        },
        compact: function (t) {
            for (var e = -1, o = null == t ? 0 : t.length, a = 0, n = []; ++e < o;) {
                var i = t[e];
                i && (n[a++] = i);
            }
            return n;
        },
        defaultTo: function (t, e) {
            return null == t || t != t ? e : t;
        },
    }),
    (slate.rte = {
        wrapTable: function () {
            $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
        },
        iframeReset: function () {
            var t = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                e = t.add(".rte iframe#admin_bar_iframe");
            t.each(function () {
                $(this).wrap('<div class="rte__video-wrapper"></div>');
            }),
                e.each(function () {
                    this.src = this.src;
                });
        },
    }),
    (slate.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            $(document)
                .on("shopify:section:load", this._onSectionLoad.bind(this))
                .on("shopify:section:unload", this._onSectionUnload.bind(this))
                .on("shopify:section:select", this._onSelect.bind(this))
                .on("shopify:section:deselect", this._onDeselect.bind(this))
                .on("shopify:section:reorder", this._onReorder.bind(this))
                .on("shopify:block:select", this._onBlockSelect.bind(this))
                .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
        _createInstance: function (t, e) {
            var o = $(t),
                a = o.attr("data-section-id"),
                n = o.attr("data-section-type");
            if (void 0 !== (e = e || this.constructors[n])) {
                var i = $.extend(new e(t), { id: a, type: n, container: t });
                this.instances.push(i);
            }
        },
        _onSectionLoad: function (t) {
            var e = $("[data-section-id]", t.target)[0];
            e && this._createInstance(e);
        },
        _onSectionUnload: function (t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && ("function" == typeof e.onUnload && e.onUnload(t), (this.instances = slate.utils.removeInstance(this.instances, "id", t.detail.sectionId)));
        },
        _onSelect: function (t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onSelect && e.onSelect(t);
        },
        _onDeselect: function (t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onDeselect && e.onDeselect(t);
        },
        _onReorder: function (t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onReorder && e.onReorder(t);
        },
        _onBlockSelect: function (t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        },
        _onBlockDeselect: function (t) {
            var e = slate.utils.findInstance(this.instances, "id", t.detail.sectionId);
            e && "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        },
        register: function (t, e) {
            (this.constructors[t] = e),
                $("[data-section-type=" + t + "]").each(
                    function (t, o) {
                        this._createInstance(o, e);
                    }.bind(this)
                );
        },
    })),
    (slate.Currency = {
        formatMoney: function (t, e) {
            function o(t, e, o, a) {
                if (((e = slate.utils.defaultTo(e, 2)), (o = slate.utils.defaultTo(o, ",")), (a = slate.utils.defaultTo(a, ".")), isNaN(t) || null == t)) return 0;
                var n = (t = (t / 100).toFixed(e)).split(".");
                return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (n[1] ? a + n[1] : "");
            }
            "string" == typeof t && (t = t.replace(".", ""));
            var a = "",
                n = /\{\{\s*(\w+)\s*\}\}/,
                i = e || "${{amount}}";
            switch (i.match(n)[1]) {
                case "amount":
                    a = o(t, 2);
                    break;
                case "amount_no_decimals":
                    a = o(t, 0);
                    break;
                case "amount_with_space_separator":
                    a = o(t, 2, " ", ".");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    a = o(t, 0, ",", ".");
                    break;
                case "amount_no_decimals_with_space_separator":
                    a = o(t, 0, " ");
            }
            return i.replace(n, a);
        },
    }),
    (slate.Image = {
        preload: function (t, e) {
            "string" == typeof t && (t = [t]);
            for (var o = 0; o < t.length; o++) {
                var a = t[o];
                this.loadImage(this.getSizedImageUrl(a, e));
            }
        },
        loadImage: function (t) {
            new Image().src = t;
        },
        imageSize: function (t) {
            var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
            return e ? e[1] : null;
        },
        getSizedImageUrl: function (t, e) {
            if (null === e) return t;
            if ("master" === e) return this.removeProtocol(t);
            var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (o) {
                var a = t.split(o[0]),
                    n = o[0];
                return this.removeProtocol(a[0] + "_" + e + n);
            }
            return null;
        },
        removeProtocol: function (t) {
            return t.replace(/http(s)?:/, "");
        },
    }),
    (slate.Variants = (function () {
        function t(t) {
            (this.$container = t.$container),
                (this.product = t.product),
                (this.singleOptionSelector = t.singleOptionSelector),
                (this.originalSelectorId = t.originalSelectorId),
                (this.enableHistoryState = t.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
        }
        return (
            (t.prototype = $.extend({}, t.prototype, {
                _getCurrentOptions: function () {
                    var t = $.map($(this.singleOptionSelector, this.$container), function (t) {
                        var e = $(t),
                            o = e.attr("type"),
                            a = {};
                        return "radio" === o || "checkbox" === o ? !!e[0].checked && ((a.value = e.val()), (a.index = e.data("index")), a) : ((a.value = e.val()), (a.index = e.data("index")), a);
                    });
                    return slate.utils.compact(t);
                },
                _getVariantFromOptions: function () {
                    var t = this._getCurrentOptions(),
                        e = this.product.variants,
                        o = !1;
                    return (
                        e.forEach(function (e) {
                            var a = !0;
                            t.forEach(function (t) {
                                a && (a = t.value === e[t.index]);
                            }),
                                a && (o = e);
                        }),
                        o || null
                    );
                },
                _onSelectChange: function () {
                    var t = this._getVariantFromOptions();
                    this.$container.trigger({ type: "variantChange", variant: t }),
                        t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t),this._updateSizeLable(t), (this.currentVariant = t), this.enableHistoryState && this._updateHistoryState(t));
                },
                _updateImages: function (t) {
                    var e = t.featured_image || {},
                        o = this.currentVariant.featured_image || {};
                    t.featured_image && e.src !== o.src && this.$container.trigger({ type: "variantImageChange", variant: t });
                },
                _updatePrice: function (t) {
                    (t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price) || this.$container.trigger({ type: "variantPriceChange", variant: t });
                },
                _updateHistoryState: function (t) {
                    if (history.replaceState && t) {
                        var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                        window.history.replaceState({ path: e }, "", e);
                    }
                },
                _updateMasterSelect: function (t) {
                    $(this.originalSelectorId, this.$container)[0].value = t.id;
                },
                _updateSizeLable: function (t) {
                    $('.sz-value').text(t.option2);
                },
            })),
            t
        );
    })()),
    (theme.Product = (function () {
        function t(t) {
            if (((this.$container = $(t)), $(e.productJson, this.$container).html())) {
                this.$container.attr("data-section-id"), (this.productSingleObject = JSON.parse($(e.productJson, this.$container).html()));
                var o = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: e.singleOptionSelector,
                    originalSelectorId: e.originalSelectorId,
                    product: this.productSingleObject,
                };
                (this.settings = {}),
                    (this.namespace = ".product"),
                    (this.variants = new slate.Variants(o)),
                    (this.$featuredImage = $(e.productFeaturedImage, this.$container)),
                    this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this)),
                    this.$container.on("variantPriceChange" + this.namespace, this.updateProductPrices.bind(this)),
                    this.$featuredImage.length > 0 &&
                    ((this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr("src"))),
                        slate.Image.preload(this.productSingleObject.images, this.settings.imageSize),
                        this.$container.on("variantImageChange" + this.namespace, this.updateProductImage.bind(this)));
            }
        }
        var e = {
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            comparePrice: "[data-compare-price]",
            comparePriceText: "[data-compare-text]",
            originalSelectorId: "[data-product-select]",
            priceWrapper: "[data-price-wrapper]",
            productFeaturedImage: "[data-product-featured-image]",
            productJson: "[data-product-json]",
            productPrice: "[data-product-price]",
            productThumbs: "[data-product-single-thumbnail]",
            singleOptionSelector: "[data-single-option-selector]",
            afterPaySelector: "#afterpay_instalments",
            cartJson: "[data-cart-json]"
        };
        return (
            (t.prototype = $.extend({}, t.prototype, {
                updateAddToCartState: function (t) {
                    var preorder_info = JSON.parse($('[data-preorder-json]').html());
                    var o = t.variant;
                    var pol = preorder_info[o.id].variant_policy;
                    var qt = preorder_info[o.id].variant_qty;
                    var is_preorder = preorder_info.is_preorder;
                    // Mothers Day
                    if (Shopify.GWP_PROMO) {
                        var total_price = 0,
                            has_free_gwp = false,
                            CURRENT_PRODUCT = window.CURRENT_PRODUCT;
                        
                        var items = Shopify.cart_items || window.items;
                        $(items).each(function (t, e) {
                            var item = 'item' in e ? e.item : e;
                            // console.log(e.item.line_price, e.item.product_type);
                            if (item.product_type != "Gift Certificate") {
                                total_price = total_price + item.line_price;
                            }
                            if (item.line_price == 0) {
                                has_free_gwp = true;
                            }
                            // console.log(item);
                        });
                        // console.log(items, has_free_gwp, CURRENT_PRODUCT.tags);
                        if (total_price >= 40000 && !has_free_gwp && CURRENT_PRODUCT.tags.indexOf('gift-3') !== -1) {
                            theme.strings.addToCart = 'GET IT FOR FREE';
                        } else {
                            theme.strings.addToCart = 'ADD TO CART';
                        }
                        // Mothers Day
                    }
                    if (!o)
                        return (
                            $(e.addToCart, this.$container).prop("disabled", !0),
                            $("#product__sticky").find(".btn--add-to-cart").prop("disabled", !0),
                            $(e.addToCartText, this.$container).html(theme.strings.unavailable),
                            $("#product__sticky").find(".btn--add-to-cart").html(theme.strings.unavailable),
                            void $(e.priceWrapper, this.$container).addClass("hide")
                        );
                    $(e.priceWrapper, this.$container).removeClass("hide");
                    if(qt>0){
                            $(e.addToCart, this.$container).prop("disabled", !1),$(e.addToCart).removeClass('btn--preorder'),
                            $(e.addToCartText, this.$container).html(theme.strings.addToCart)
                            
                            if (Shopify.GWP_PROMO) { changeCTAMothersDay($(e.addToCartText))}
                            
                            $("#product__sticky").find(".btn--add-to-cart").prop("disabled", !1).html(theme.strings.addToCart),
                            ($('.preorder-inp').find('input#inpt-pre-order').length > 0) ? $('.preorder-inp').html('') : '',
                            $('.preorder-msg').addClass('hide'),($('.preorder-msg').find('.pre-order-message').length > 0) ? $('.preorder-msg').html('') : '';
                    }else{
                        if(pol == 'deny'){
                            $(e.addToCart, this.$container).prop("disabled", !0),$(e.addToCart).removeClass('btn--preorder'),
                            $(e.addToCartText, this.$container).html(theme.strings.soldOut),
                            $("#product__sticky").find(".btn--add-to-cart").prop("disabled", !0).html(theme.strings.soldOut),
                            ($('.preorder-inp').find('input#inpt-pre-order').length > 0) ? $('.preorder-inp').html('') : '',
                            $('.preorder-msg').addClass('hide'),($('.preorder-msg').find('.pre-order-message').length > 0) ? $('.preorder-msg').html('') : '';
                        }else{
                            if(is_preorder){
                                $(e.addToCart, this.$container).prop("disabled", !1),$(e.addToCart).addClass('btn--preorder'),
                                $(e.addToCartText, this.$container).html(theme.strings.preorderButton),
                                $("#product__sticky").find(".btn--add-to-cart").prop("disabled", !1).html(theme.strings.preorderButton),
                                ($('.preorder-inp').find('input#inpt-pre-order').length == 0) ? $('.preorder-inp').html('<input type="hidden" id="inpt-pre-order" name="properties['+theme.strings.preorderProperty.split(':')[0]+']" value="'+theme.strings.preorderProperty.split(':')[1]+'">') : '',
                                $('.preorder-msg').removeClass('hide'),($('.preorder-msg').find('.pre-order-message').length == 0) ? $('.preorder-msg').html('<span class="pre-order-message">'+theme.strings.preorderMsg+'</span>') : '';
                            }else{
                                $(e.addToCart, this.$container).prop("disabled", !1),$(e.addToCart).removeClass('btn--preorder'),
                                $(e.addToCartText, this.$container).html(theme.strings.addToCart);
                                if (Shopify.GWP_PROMO) { changeCTAMothersDay($(e.addToCartText))}
                                $("#product__sticky").find(".btn--add-to-cart").prop("disabled", !1).html(theme.strings.addToCart),
                                ($('.preorder-inp').find('input#inpt-pre-order').length > 0) ? $('.preorder-inp').html('') : '',
                                $('.preorder-msg').addClass('hide'),($('.preorder-msg').find('.pre-order-message').length > 0) ? $('.preorder-msg').html('') : '';
                            }
                        } 
                    }
                },
                updateProductPrices: function (t) {
                    var o = t.variant,
                        a = $(e.comparePrice),
                        n = a.add(e.comparePriceText);
                    $(e.productPrice).html(slate.Currency.formatMoney(o.price, theme.moneyFormat)),
                        $(e.productPrice).attr("data-money", o.price),
                        $(e.afterPaySelector)
                            .attr("data-money", Math.round(o.price / 4))
                            .html(slate.Currency.formatMoney(Math.round(o.price / 4), theme.moneyFormat)),
                        o.compare_at_price > o.price ? (a.html(slate.Currency.formatMoney(o.compare_at_price, theme.moneyFormat)), a.attr("data-money", o.compare_at_price), n.removeClass("hide")) : (a.html(""), n.addClass("hide")),
                        window.Currency.updatePrices();
                },
                updateProductImage: function (t) {
                    var e = t.variant,
                        o = slate.Image.getSizedImageUrl(e.featured_image.src, this.settings.imageSize);
                    this.$featuredImage.attr("src", o);
                },
                onUnload: function () {
                    this.$container.off(this.namespace);
                },
            })),
            t
        );
    })()),
    (theme.customerAddresses = (function () {
        var t = $("#AddressNewForm");
        t.length &&
            (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                $(".address-country-option").each(function () {
                    var t = $(this).data("form-id"),
                        e = "AddressCountry_" + t,
                        o = "AddressProvince_" + t,
                        a = "AddressProvinceContainer_" + t;
                    new Shopify.CountryProvinceSelector(e, o, { hideElement: a });
                }),
                $(".address-new-toggle").on("click", function () {
                    t.toggleClass("hide");
                }),
                $(".address-edit-toggle").on("click", function () {
                    var t = $(this).data("form-id");
                    $("#EditAddress_" + t).toggleClass("hide");
                }),
                $(".address-delete").on("click", function () {
                    var t = $(this),
                        e = t.data("form-id"),
                        o = t.data("confirm-message");
                    confirm(o || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + e, { parameters: { _method: "delete" } });
                }));
    })()),
    (theme.customerLogin = (function () {
        function t(t) {
            t.preventDefault(), e();
        }
        function e() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
        }
        var o = "#RecoverPassword";
        $(o).length && ("#recover" === window.location.hash && e(), $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"), $(o).on("click", t), $("#HideRecoverPasswordLink").on("click", t));
    })());
    theme.ProductVideos = function () {
        function t(t) {
            e(t), $(window).on("scroll." + t, { id: t }, $.throttle(150, e));
        }
        function e(t) {
            var e, o;
            if (((e = "string" == typeof t ? t : t.data.id), theme.isElementVisible($("#" + e)))) {
                if (c[e] && "unmuted" === c[e].style) return;
                s[(o = e)] && "function" == typeof s[o].playVideo && s[o].playVideo();
            } else
                !(function (t) {
                    s[t] && "function" == typeof s[t].pauseVideo && s[t].pauseVideo();
                })(e);
        }
        function o(t) {
            t.closest(r.videoParent).addClass(i.loading);
        }
        function a(t) {
            t.closest(r.videoParent).removeClass(i.loading).addClass(i.loaded);
        }
        var n,
            i = { onSale: "on-sale", disabled: "disabled", isModal: "is-modal", loading: "loading", loaded: "loaded", interactable: "video-interactable" },
            r = { productVideo: ".product__video", videoParent: ".product__video-wrapper", currentSlide: ".slick-current" },
            c = {},
            s = [],
            l = {
                height: "480",
                width: "850",
                playerVars: { autohide: 0, autoplay: 1, branding: 0, cc_load_policy: 0, controls: 0, fs: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 1, quality: "hd720", rel: 0, showinfo: 0, wmode: "opaque" },
                events: {
                    onReady: function (e) {
                        var n = $(e.target.a),
                            i = n.attr("id");
                        (s[i] = e.target),
                            s[i],
                            o(n),
                            "muted" === c[i].style ? s[i].mute().playVideo().pauseVideo() : a(n),
                            (!n.closest(r.currentSlide).length && 1 !== n.data("image-count")) || "muted" !== c[i].style || (s[i].playVideo(), t(i));
                    },
                    onStateChange: function (t) {
                        var e = $(t.target.a),
                            o = e.attr("id"),
                            n = s[o];
                        switch (t.data) {
                            case -1:
                                c[o].attemptedToPlay && (a(e), e.closest(t.videoParent).addClass(i.interactable));
                                break;
                            case 0:
                                n.playVideo();
                                break;
                            case 1:
                                a(e);
                                break;
                            case 3:
                                c[o].attemptedToPlay = !0;
                        }
                    },
                },
            },
            d = [],
            u = { byline: !1, title: !1, portrait: !1, loop: !0 },
            m = {
                checkIfVideos: function () {
                    var t = m.$mainSlider.find(r.productVideo);
                    if (!t.length) return !1;
                    var e = [];
                    return (
                        t.each(function () {
                            var t = $(this).data("video-type");
                            e.indexOf(t) < 0 && e.push(t);
                        }),
                        e.indexOf("youtube") > -1 &&
                        (theme.config.youTubeReady
                            ? m.loadYoutubeVideos(t)
                            : (window.loadYouTube(),
                                $("body").on(
                                    "youTubeReady" + this.settings.namespace,
                                    function () {
                                        m.loadYoutubeVideos(t);
                                    }.bind(this)
                                ))),
                        e.indexOf("vimeo") > -1 &&
                        (n
                            ? m.loadVimeoVideos(t)
                            : (window.loadVimeo(),
                                $("body").on(
                                    "vimeoReady" + this.settings.namespace,
                                    function () {
                                        m.loadVimeoVideos(t);
                                    }.bind(this)
                                ))),
                        e.indexOf("mp4") > -1 && m.loadMp4Videos(t),
                        e
                    );
                },
                loadMp4Videos: function (t) {
                    t.each(function () {
                        var t = $(this);
                        if ("mp4" == t.data("video-type")) {
                            var e = t.attr("id");
                            t.data("video-id"), (c[this.id] = { type: "mp4", divId: e, style: t.data("video-style") });
                        }
                    });
                },
                loadVimeoVideos: function (t) {
                    var e;
                    for (e in (t.each(function () {
                        var t = $(this);
                        if ("vimeo" == t.data("video-type")) {
                            var e = t.attr("id"),
                                o = t.data("video-id");
                            c[m.id] = { type: "vimeo", divId: e, id: o, style: t.data("video-style"), width: t.data("video-width"), height: t.data("video-height") };
                        }
                    }),
                        c))
                        if ("vimeo" == c[e].type) {
                            var o = $.extend({}, u, c[e]);
                            d[e] = new Vimeo.Player(c[e].divId, o);
                        }
                    n = !0;
                },
                autoplayVimeoVideo: function (t) {
                    theme.config.bpSmall ? a($("#" + t)) : m.requestToPlayVimeoVideo(t);
                },
                requestToPlayVimeoVideo: function (t) {
                    o($("#" + t)),
                        n
                            ? m.playVimeoVideo(t)
                            : $("body").on(
                                "vimeoReady" + this.settings.namespace,
                                function () {
                                    m.playVimeoVideo(t);
                                }.bind(this)
                            );
                },
                playVimeoVideo: function (t) {
                    d[t].play(), "muted" === c[t].style && d[t].setVolume(0), a($("#" + t));
                },
                stopVimeoVideo: function (t) {
                    if (theme.config.vimeoReady)
                        if (t) d[t].pause();
                        else for (key in d) "function" == typeof d[key].pause && d[key].pause();
                },
                loadYoutubeVideos: function (t) {
                    var e;
                    for (e in (t.each(function () {
                        var t = $(this);
                        if ("youtube" == t.data("video-type")) {
                            var e = t.attr("id"),
                                o = t.data("youtube-id");
                            c[m.id] = { type: "youtube", id: e, videoId: o, style: t.data("video-style"), width: t.data("video-width"), height: t.data("video-height"), attemptedToPlay: !1 };
                        }
                    }),
                        c))
                        if ("youtube" === c[e].type && c.hasOwnProperty(e)) {
                            var o = $.extend({}, l, c[e]);
                            "muted" !== o.style && ((o.playerVars.controls = 1), (o.playerVars.autoplay = 0)), (s[e] = new YT.Player(e, o));
                        }
                },
                requestToPlayYoutubeVideo: function (t, e) {
                    if (theme.config.youTubeReady)
                        if ((o($("#" + t)), "function" == typeof s[t].playVideo)) this.playYoutubeVideo(t, e);
                        else {
                            var a = this;
                            setTimeout(function () {
                                a.playYoutubeVideo(t, e);
                            }, 1e3);
                        }
                },
                playYoutubeVideo: function (e, o) {
                    a($("#" + e)), "function" == typeof s[e].playVideo && s[e].playVideo(), o || t(e);
                },
                stopYoutubeVideo: function (t) {
                    if (theme.config.youTubeReady)
                        if (t && s[t]) "function" == typeof s[t].pauseVideo && s[t].pauseVideo(), $(window).off("scroll." + t);
                        else for (key in s) "function" == typeof s[key].pauseVideo && (s[key].pauseVideo(), $(window).off("scroll." + key));
                },
                playMp4Video: function (t) {
                    a($("#" + t));
                    var e = document.getElementById(t);
                    e.pause(), (e.currentTime = 0), e.play();
                },
                stopMp4Video: function (t) {
                    var e;
                    if (t) $("#" + t)[0].pause();
                    else
                        for (e in c)
                            if ("mp4" === c[e].type) {
                                var o = $("#" + c[e].divId)[0];
                                "function" == typeof o.pause && o.pause();
                            }
                },
                isVideo: function (t) {
                    for (var e = {}, o = ["youtube.com/watch", "youtu.be/", "vimeo.com", ".mp4"], a = 0; a < o.length; a++)
                        if (t.includes(o[a]))
                            if ((t.indexOf("|") > -1 ? (e.url = t.split("|")[1]) : t.indexOf("|") < 0 && (e.url = t), "youtube.com/watch" == o[a])) {
                                var n = e.url.split("v=");
                                (e.id = n[1].split("&")[0]), (e.type = "youtube");
                            } else
                                "youtu.be/" == o[a]
                                    ? ((e.type = "youtube"), (n = e.url.split(".be/")), (e.id = n[1].split("&")[0]))
                                    : "vimeo.com" == o[a]
                                        ? ((e.type = "vimeo"), (n = e.url.split(".com/")), (e.id = n[1].split("/")[0]))
                                        : ".mp4" == o[a] && (e.type = "mp4");
                    return "url" in e && e;
                },
            };
        return m;
    };

    class ProductImageSlider {

        constructor(){
            this.config = {
                pv: theme.ProductVideos(),
                initialization_delay: 1500,
                images: Shopify.productImages,
                gallery_container: $("#gallery-container"),
                main: "#gallery-container .gallery-slider",
                thumb: "#penguin-container",
                thumb_item: "#penguin-container li",
                main_item: "#gallery-container .gallery-slider a",
                loader: $(".product__image-loader"),
                wrap: $(".product__image-wrapper"),
                colorSelector: $(".product__variant-thumbs li"),
                sizeSelector: $("#sizeSelector .custom-option"),
                variant_select: $("#SingleOptionSelector-0"),
                size_select: $("#SingleOptionSelector-1"),
                fancyitem: ".fancybox-item",
                video_icon:
                    '<span class="product__thumb-icon"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" viewBox="18.24 17.35 24.52 28.3"><path fill="#323232" d="M22.1 19.151v25.5l20.4-13.489-20.4-12.011z"></path></svg></span>',
            }
        }

        
        init(){

            if ($.isEmptyObject(this.config.images)) return;

            const self = this
            self.updateStockDisplay();

            setTimeout(() => {
                $(self.config.thumb_item).each(function (t) {
                    if(t == 0) return;
                    var $item = $(this);
                    if ($item.data("color") && $item.css("display") === "list-item") {
                        $(self.config.main).append(
                            self.slideContent($item,t)
                        );
                    }
                });
                self.initializeFancybox();
                self.initializeSliders();
                $('.image-wrap').removeClass('placeholder-slide')
                self.config.loader.hide();
            }, self.config.initialization_delay)

            self.config.sizeSelector.on("click", function () {
                var size = $(this).data("value");
                self.config.size_select.val(size).trigger("change");
                $("#sizeSelector .custom-option").removeClass("selected");
                $(this).addClass("selected");
            });
            
            self.config.size_select.on("change", self.updateStockDisplay);
    
            self.config.colorSelector.on("click", function () {

                var color = $(this).data("color");
                self.showSelectedOption(color);
                self.updateStockDisplay();
                $(this).data("available") ? $(".product__lowstock").removeClass("hidden") : $(".product__lowstock").addClass("hidden");
                $(".product__image-main img").hide();
                self.config.variant_select.val(color).trigger("change");
                $(".product__image-main img").fadeIn();
                $(".product__variant-thumbs li").removeClass("selected");
                $(this).addClass("selected");

                self.rebuildSlider(color)
                
                var unavailableSizes = $("script[data-product-sizings]").html().split(",");
                $("#sizeSelector .custom-option").removeClass("disabled");
                
                $.each(unavailableSizes, function (i, unavailableSize) {
                    var unavailableSizeParts = unavailableSize.split(" / ");
                    if (unavailableSizeParts[0] === color) {
                        $("#sizeSelector .custom-option[data-value='" + unavailableSizeParts[1] + "']").addClass("disabled");
                    }
                });
            });
        }

        encodeString(t) {
            if ((t = btoa(t)).length % 5 !== 0) {
                var e = (t.length + 1) / 5;
                return t.slice(e - 5, e + 1);
            }
            return t;
        }
    
        updateStockDisplay() {
            setTimeout(function () {
                var wrapper = $(".spurit-po-wrapper");
                var upperMsg = $(".spurit-upper-msg");
                var lowStock = $(".product__lowstock");
    
                $("[data-lowstock]").attr("data-current-variant", $('[name="id"]').val());
    
                if (wrapper.length) {
                    lowStock.removeClass("is-visible");
                    upperMsg.removeClass("hidden");
                } else {
                    updateLowStock();
                    upperMsg.addClass("hidden");
                }
            }, 500);
        }
    
        initializeSliders() {
            const self = this
            const mainSlider = this.config.main
            const thumbnailSlider = this.config.thumb

            $(mainSlider).off("beforeChange").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                var currentSlideLink = $(this).find('[data-slick-index="' + nextSlide + '"] .image-wrap a');
                var productVideo = self.config.pv;
                var videoId = "ProductVideo-" + nextSlide;
            
                if (currentSlideLink.hasClass("has-video")) {
                    var videoElement = document.getElementById(videoId);
                    var videoAspectRatio = videoElement.videoWidth / videoElement.videoHeight;
                    productVideo.playMp4Video(videoId);
                } else {
                    videoAspectRatio = currentSlideLink.find("img").data("aspect-ratio");
                    productVideo.stopMp4Video();
                }
            
                $(mainSlider)
                .find(".image-wrap")
                .css("padding-bottom", 100 / videoAspectRatio + "%");
            });

            $(mainSlider).off("init").on("init", function (event, slick) {
                $(document).on("lazyloaded", function (event) {
                    $(event.target).parents(".image-wrap").addClass("image-loaded").removeClass("main-loading");
                });
            });
            
            $(thumbnailSlider).off("init")
            $(thumbnailSlider).off("beforeChange").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                if ($(window).width() > 579) {
                    $(thumbnailSlider + " .slick-track").css("padding-top", nextSlide === 0 ? 0 : "50px");
                }
            });
            
            $(mainSlider)
                .not(".slick-initialized")
                .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                asNavFor: thumbnailSlider,
                infinite: false,
                dots: false,
                prevArrow: '<div class="slick-control slick-prev"><img src="' + theme.soldout_url.replace("soldout.png", "left-arrow.svg") + '"/></div>',
                nextArrow: '<div class="slick-control slick-next"><img src="' + theme.soldout_url.replace("soldout.png", "right-arrow.svg") + '"/></div>',
                responsive: [{ breakpoint: 580, settings: { arrows: true, fade: false, infinite: false, dots: true, adaptiveHeight: true } }],
            });
            
            $(thumbnailSlider)
            .not(".slick-initialized")
            .slick({
                slide: ".slide",
                slidesToShow: 4,
                slidesToScroll: 1,
                vertical: true,
                asNavFor: mainSlider,
                dots: false,
                focusOnSelect: true,
                verticalSwiping: true,
                arrow: false,
                infinite: false,
                customHeightMatching: true,
                responsive: [
                    { breakpoint: 580, settings: "unslick" },
                    { breakpoint: 850, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                ],
            });
            
            $(window).resize(function () {
                $(thumbnailSlider).slick("slickSetOption", "customHeightMatching", true, true);
            });
        }
    
        initializeFancybox() {
            const self = this
            $(self.config.fancyitem).fancybox({
                buttons: ["close"],
                mobile: { clickContent: "close", clickSlide: "close" },
                closeClickOutside: true,
                afterShow: function (t, o) {
                    var $slickSlide = $(self.config.thumb + " .slick-slide");
                    $slickSlide.removeClass("slick-current slick-center");
                    $slickSlide.not(".slick-cloned").eq(o.index).addClass("slick-current slick-center");
                
                    if (o.contentType === "video") {
                        var $video = o.$content.find("video");
                        var videoElement = $video.get(0);
                
                        if (videoElement.paused) {
                            $video.attr("playsinline", "").attr("id", "fancybox-video-" + o.index);
                            videoElement.muted = true;
                            videoElement.loop = true;
                            videoElement.autoplay = true;
                            videoElement.controls = true;
                            videoElement.load();
                    
                            var playPromise = videoElement.play();
                    
                            if (playPromise !== undefined) {
                                playPromise.then(function () {
                                    console.log("Fancybox video played!");
                                }).catch(function (error) {
                                    console.log("User action required");
                                });
                            }
                        }
                    }
                },
                beforeClose: function (t, o) {
                    $(self.config.thumb).slick("slickGoTo", o.index);
                },
            });
        }

        showSelectedOption(t){
            if ($(window).width() < 850) {
                $(".option-value").text(t);
                $(".product__type").text(t);
                $(".product__color_swatch").attr('style', $('ul.color-thumbnail li[data-color="'+t+'"]').attr('style'));
            } else {
                $(".option-value").text(t);
                $(".product__type").hide();
            }
        }
        
        videoSlide(videoObj,posterUrl,index) {
            const videoLink = videoObj.url || videoObj.video
            return `
            <div class="product-image-main">
                <div class="image-wrap" style="height: 0;">
                    <a data-fancybox="gallery" class="fancybox-item has-video" href="${videoLink}">
                        <div id="${this.encodeString(videoLink)}">
                            <video muted="muted" loop playsinline controls poster="https:${posterUrl}" controlsList="nodownload" data-video-type="mp4" id="ProductVideo-${index}" class="product__video">
                                <source src="${videoLink}" type="video/mp4">
                            </video>
                        </div>
                    </a>
                </div>
            </div>
            `
        }

        imageSlide(alt,imageSrc,aspectRatio,index) {
            return `
            <div class="product-image-main">
                <div class="image-wrap" style="height: 0; padding-bottom: ${100 / aspectRatio}%;">
                    <a data-fancybox="gallery" class="fancybox-item" href="${imageSrc}">
                        <img alt="${alt}"
                            class="lazyautosizes lazyload"
                            data-aspect-ratio="${aspectRatio}"
                            data-sizes="auto"
                            data-src="${imageSrc}"
                            data-widths="[360, 540, 720, 900, 1080]"
                            src="${imageSrc.replace("_600x", "_100x")}"
                        />
                        <noscript>
                            <img class="lazyloaded" src="${imageSrc}" alt="${alt}">
                        </noscript>
                    </a>
                </div>
            </div>
            `
        }

        slideContent($item,index) {

            var aspectRatio = $item.find(".image-wrap").data("aspect-ratio");
            var href = $item.find(".image-wrap").data("href");
            var alt = $item.find("img").attr("alt");
            var videoObj = this.config.pv.isVideo(alt);

            return  videoObj && videoObj.type === "mp4"
                    ? this.videoSlide(videoObj,href,index)
                    : this.imageSlide($item.data("color"),href,aspectRatio,index)
        }

        rebuildSlider(color){

            const self = this
            const config = this.config
            const images = config.images[color];
            if (!images.length) return

            const mainSlider = config.main
            const thumbnailSlider = config.thumb

            $(mainSlider + ".slick-initialized").slick("unslick");
            $(mainSlider).html(`
            <div class="product-image-main">
                <div class="image-wrap placeholder-slide" style="position:relative;height: 0; padding-bottom: ${100/images[0].aspect_ratio}%;">   

                </div>
                <div class="product__image-loader">
                    <div class="spinner">
                        <div class="double-bounce1"></div>
                        <div class="double-bounce2"></div>
                    </div>
                </div>
            </div>
            `);
            $(thumbnailSlider + ".slick-initialized").slick("unslick");
            $(thumbnailSlider).empty();
            var index = 0;
        
            $.each(images, function (i, thumbSlide) {
                var aspectRatio = thumbSlide.aspect_ratio;
                var videoObj = "object" === typeof thumbSlide && "video" in thumbSlide && config.pv.isVideo(thumbSlide.video);
                var videoPoster = videoObj ? thumbSlide.poster : thumbSlide.image.replace("_medium", "_600x");
                var isVideoSlide = false;
        
                if (videoObj && "mp4" === videoObj.type) {
                    $(mainSlider).append(
                        self.videoSlide(videoObj,videoPoster,index)
                    );
                    isVideoSlide = true;
                } else {
                    $(mainSlider).append(
                        self.imageSlide(color,videoPoster,aspectRatio,i)
                    );
                }
        
                $(thumbnailSlider).append(`
                    <li class="slide${isVideoSlide ? " only-videos" : ""}" data-color="${isVideoSlide ? isVideo.url : color}">
                        <div style="height: 0; padding-bottom: ${100 / aspectRatio}%;" data-aspect-ratio="${aspectRatio}" class="image-wrap${isVideoSlide ? " has-video" : ""}" data-href="${thumbSlide}">
                        ${isVideoSlide ? config.video_icon : ""}
                        <img src="${thumbSlide.image.replace("_medium", "_80x")}" alt="${color}">
                        </div>
                    </li>
                `);
        
                index++;
            });
        
            $(config.images.VIDEOS).each(function (i, video) {
                $(mainSlider).append(
                    self.videoSlide(video,video.poster,index)
                );
        
                $(thumbnailSlider).append(`
                    <li class="slide only-videos" data-color="${video.video}">
                        <div style="height: 0; padding-bottom: ${100 / video.aspect_ratio}%;" data-aspect-ratio="${video.aspect_ratio}" class="image-wrap has-video" data-href="${video.poster.replace("_medium", "_600x")}">
                        ${config.video_icon}
                        <img src="${video.poster.replace("_medium", "_80x")}" alt="${video.video}">
                        </div>
                    </li>
                `);
        
                index++;
            });

            $(mainSlider).find('.product-image-main').first().remove()
            this.initializeFancybox();
            this.initializeSliders();
        }
    }

    const productImageSlider = new ProductImageSlider()

    $(document).ready(function () {
        if ($(".cookie-popup").length) {
            $(".cookie-popup").css("display", "block"), void 0 === $.cookie("notice-accepted") ? $(".cookie-accept").click(function () {
                $.cookie("notice-accepted", "1", {
                    expires: 14,
                    path: "/"
                }), $(".cookie-popup").fadeOut()
            }) : $(".cookie-popup").css("display", "none");
        }
        function t(t) {
            $(window).width() < 850 ? ($(".option-value").text(t),$(".product__type").text(t),$(".product__color_swatch").attr('style',$('ul.color-thumbnail li[data-color="'+t+'"]').attr('style'))) : ($(".option-value").text(t), $(".product__type").hide());
        }
        function sz(t) {
            $(window).width() < 850 ? ($(".sz-value").text(t)) : ($(".sz-value").text(t));
        }


        new slate.Sections().register("product", theme.Product);
        slate.a11y.pageLinkFocus($(window.location.hash));
        $(".in-page-link").on("click", function (t) {
            slate.a11y.pageLinkFocus($(t.currentTarget.hash));
        });
        slate.rte.wrapTable();
        slate.rte.iframeReset();
        if (slate.cart.cookiesEnabled()) {
            document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
        }

        // $(".owl-carousel").owlCarousel({ margin: 0, nav: false, items: 1, autoplay: true, autoplayTimeout: 5e3, autoplayHoverPause: true });

        $(window).scroll(function (t) {
            if ($(".product__image-wrapper__thumbs").length) {
                $(window).scrollTop();
                if ($(".product__image-wrapper__thumbs").offset().top - $(window).scrollTop() <= 68) {
                    $(".product__image-wrapper__thumbs").addClass("scrolled-up");
                } else {
                    $(".product__image-wrapper__thumbs").removeClass("scrolled-up");
                }
            }
        });

        $(".menu-toggle-shop").on("click", function (t) {
            t.stopPropagation();
            $(".menu-overlay-fixed").fadeToggle(300);
            $("html").toggleClass("menu-open");
            $("body").toggleClass("menu-open");
            $(".product__image-wrapper__thumbs").toggleClass("menu-open");
            if ($("body").hasClass("menu-open")) {
                $("#menu-toggle").html(
                    '<div class="close-icon"><button class="side-menu__close__button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="240" height="240" viewBox="0 0 60 60"><path fill-rule="evenodd"  fill="rgb(59, 59, 58)"d="M34.582,28.975 L60.214,53.349 C61.226,54.309 61.226,55.869 60.214,56.830 C59.708,57.310 59.046,57.551 58.383,57.551 C57.720,57.551 57.058,57.310 56.552,56.830 L30.921,32.457 L5.290,56.830 C4.784,57.310 4.123,57.551 3.459,57.551 C2.796,57.551 2.134,57.310 1.628,56.830 C0.616,55.869 0.616,54.309 1.628,53.349 L27.260,28.975 L1.628,4.601 C0.616,3.640 0.616,2.081 1.628,1.120 C2.641,0.157 4.278,0.157 5.290,1.120 L30.921,25.493 L56.552,1.120 C57.564,0.157 59.202,0.157 60.214,1.120 C61.226,2.081 61.226,3.640 60.214,4.601 L34.582,28.975 Z"/></svg></button> </div>'
                );
            } else {
                $("#menu-toggle").html("&#9776;");
            }
        });

        $("#menu-toggle").on("click", function () {
            $(".menu-overlay-fixed").fadeToggle(300);

            const scrollToTop = "-" + $(document).scrollTop() + "px";
            const scrollToTopDist = $(document).scrollTop() + "px";
            $("html,body").toggleClass("menu-open").attr('data-scrolled', scrollToTopDist);
            $("html,body").css("top", scrollToTop);

            $(".product__image-wrapper__thumbs").toggleClass("menu-open");
            if ($("body").hasClass("menu-open")) {
                $(this).html(
                    '<div class="close-icon"><button class="side-menu__close__button"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="240" height="240" viewBox="0 0 60 60"><path fill-rule="evenodd"  fill="rgb(59, 59, 58)"d="M34.582,28.975 L60.214,53.349 C61.226,54.309 61.226,55.869 60.214,56.830 C59.708,57.310 59.046,57.551 58.383,57.551 C57.720,57.551 57.058,57.310 56.552,56.830 L30.921,32.457 L5.290,56.830 C4.784,57.310 4.123,57.551 3.459,57.551 C2.796,57.551 2.134,57.310 1.628,56.830 C0.616,55.869 0.616,54.309 1.628,53.349 L27.260,28.975 L1.628,4.601 C0.616,3.640 0.616,2.081 1.628,1.120 C2.641,0.157 4.278,0.157 5.290,1.120 L30.921,25.493 L56.552,1.120 C57.564,0.157 59.202,0.157 60.214,1.120 C61.226,2.081 61.226,3.640 60.214,4.601 L34.582,28.975 Z"/></svg></button> </div>'
                );
            } else {
                $(this).html("&#9776;");
            }
            if ($('.cookie-popup').length) {
                $(".cookie-popup").toggleClass("cookie-menu-open");
            }
        });

        $(".side-menu__close__button").on("click", function () {
            var dataScrolled = $('html,body').attr('data-scrolled');
            $(".menu-overlay-fixed").fadeOut(300);
            $("#menu-toggle").html("&#9776;");
            $("html,body").removeClass("menu-open").removeAttr('style');
            $("html,body").animate({ scrollTop: dataScrolled }, 10);
            $("html,body").removeAttr('data-scrolled');
            $(".product__image-wrapper__thumbs").removeClass("menu-open");
            if ($('.cookie-popup').length) {
                $(".cookie-popup").removeClass("cookie-menu-open");
            }
        });

        $("#cart-toggle").on("click", function () {
            $(".cart-overlay-fixed").fadeToggle(300);
            $("body").toggleClass("cart-open");
        });

        $(".side-cart__close").on("click", "button", function () {
            $(".cart-overlay-fixed").fadeOut(300);
            $("body").toggleClass("cart-open");
        });

        $("body").on("click", ".js-change-quantity", jsQuantitySelector);

        $("body").on("change", "#side-cart input.quantity", function () {
            if ($(this).val() == 0) {
                $(this).closest(".cart__wrapper").remove();
            }
            ajaxUpdateCart($(this).data("line-id"), $(this).val(), $(this).parents("#side-cart"));
        });

        $(window).scroll(function (t) {
            t.preventDefault();
            if ($(window).scrollTop() > 50) {
                $(".header-section header").addClass("scrolling");
                $(".home-head").addClass("scrolled");
                $("#product__sticky").show();
            } else if ($(window).scrollTop() < 1) {
                $(".header-section header").removeClass("scrolling");
                $(".home-head").removeClass("scrolled");
                $("#product__sticky").hide();
            }
        });

        t($("#SingleOptionSelector-0").val());
        sz($("#SingleOptionSelector-1").val());

        if ( window.template === "product" ) {
            productImageSlider.init()
        }
    }),
    (Object.assign =
        Object.assign ||
        function (t, e) {
            var o;
            for (o in e) t[o] = e[o];
            return t;
        }),
    String.prototype.escapeHTML ||
    (String.prototype.escapeHTML = function () {
        var t = document.createElement("div");
        return t.appendChild(document.createTextNode(this)), t.innerHTML;
    }),
    (AjaxCollection.constants = {
        urlPrefix: "/collections/",
        callsAtATime: 1,
        sort: {
            "A-Z": {
                name: "A - z",
                method: function (t, e) {
                    return t.data.title.localeCompare(e.data.title);
                },
            },
            "Z-A": {
                name: "Z - a",
                method: function (t, e) {
                    return e.data.title.localeCompare(t.data.title);
                },
            },
            "Price-Low": {
                name: "Price, Low to High",
                method: function (t, e) {
                    return t.data.price - e.data.price;
                },
            },
            "Price-High": {
                name: "Price, High to Low",
                method: function (t, e) {
                    return e.data.price - t.data.price;
                },
            },
            Page: {
                name: "Default",
                method: function (t, e) {
                    return t.order - e.order;
                },
            },
        },
    }),
    (AjaxCollection.prototype = {
        getBaseURL: function () {
            return AjaxCollection.constants.urlPrefix + this.handle;
        },
        hasMoreProducts: function () {
            return void 0 === this.total_products || this.products.length < this.total_products;
        },
        fetch: function (t) {
            if (t <= 0) throw "Page must be 1 or higher";
            if (this.hasMoreProducts()) {
                var e = { view: "json", page: t },
                    o = window.location.href.split("?")[1];
                if (void 0 !== o) var a = this.getBaseURL() + "?" + o;
                else a = this.getBaseURL();
                var n = $.ajax({ url: a, data: e, method: "GET", error: this.onError.bind(this) });
                return this.processingRequests.push(n), (n.page = t), (n.id = this.nextRequestID++), (n.self = this), n.done(this.onData.bind(n)), n;
            }
        },
        onData: function (t) {
            var e,
                o = this.self;
            o.processingRequests.splice(o.processingRequests.indexOf(this), 1);
            try {
                if (!(e = JSON.parse(t)).collection || !e.total_products || !e.products) throw "Invalid JSON";
            } catch (t) {
                return o.onError(t);
            }
            (o.id = e.collection.id), e.collection.body_html && (o.body_html = e.collection.body_html), e.collection.title && (o.title = e.collection.title), (o.total_products = e.total_products);
            for (var a = 0; a < e.products.length; a++) {
                if ((t = e.products[a]) && t.data && t.data.handle) {
                    var n = t.data.handle;
                    o.productsByHandle[n] || ((t.order = 1e4 * this.page + a), (o.productsByHandle[n] = t), (o.productsByID[t.data.id] = t), o.products.push(t));
                }
            }
            o.onRequestComplete(this);
        },
        onRequestComplete: function (t) {
            if ((jQuery(".lds-ellipsis").css("display", "flex"), this.redraw(), !this.hasFinished)) {
                for (var e = 0; e < this.productHandlers.length; e++) this.productHandlers[e].onProductsUpdated(this.products, this);
                this.onProductsFetched();
            }
            window.Currency.updatePrices(),
                this.hasMoreProducts()
                    ? this.fetch(t.page + AjaxCollection.constants.callsAtATime)
                    : this.hasFinished || ((this.hasFinished = !0), this.onCollectionFetched(), jQuery(".lds-ellipsis").css("display", "none"), this.showMore());
        },
        onError: function (t) {
            console.error("Error!"), console.error(t);
        },
        redraw: function () {
            products_to_print = [];
            for (var t = 0; t < this.products.length; t++) {
                var e = this.products[t];
                if (this.f.price) {
                    if (e.data.price < this.f.price.min) continue;
                    if ("string" != typeof this.f.price.max && e.data.price > this.f.price.max) continue;
                }
                products_to_print.push(e);
            }
            this.f.sort && products_to_print.sort(this.f.sort.method), (products_to_print = this.paginate(products_to_print));
            var o = "";
            for (t = 0; t < products_to_print.length; t++) o += this.printProduct(products_to_print[t]);
            this.container.html(o), checkCurrencyCookie();
        },
        paginate: function (t) {
            return t;
        },
        printProduct: function (t) {
            return decodeURIComponent(t.print);
        },
        filter: function (t) {
            (this.f = t), this.redraw();
            for (var e = 0; e < this.filterListeners.length; e++) this.filterListeners[e].onFilterUpdate();
        },
        sort: function (t) {
            (this.f.sort = t), this.redraw();
            for (var e = 0; e < this.filterListeners.length; e++) this.filterListeners[e].onFilterUpdate();
        },
        filterPrice: function (t, e) {
            t <= 0 && "string" == typeof e ? delete this.f.price : (this.f.price = { min: t, max: e }), this.redraw();
            for (var o = 0; o < this.filterListeners.length; o++) this.filterListeners[o].onFilterUpdate();
        },
        fetchInitial: function () {
            for (var t = 1; t <= AjaxCollection.constants.callsAtATime; t++) this.fetch(t);
        },
        onCollectionFetched: function () {
            console.log("...Done");
        },
        onProductsFetched: function () { },
    }),
    (WanderersCollectionPage.prototype = Object.assign(AjaxCollection.prototype, {
        paginate: function (t) {
            for (var e = [], o = 0; o < Math.min(this.perPage, t.length); o++) e.push(t[o]);
            return e;
        },
        showMore: function () {
            (this.perPage += 16), this.redraw(), this.perPage >= this.total_products && this.viewMore.addClass("hidden");
        },
        onScroll: function () {
            if (!(this.perPage >= this.total_products)) {
                var t = $(window).height();
                $(window).scrollTop() + t >= this.container.position().top + this.container.outerHeight(!0) - 100 && this.showMore();
            }
        },
    })),
    (WanderersCollectionPage.prototype.constructor = WanderersCollectionPage),
    $(".pc-infinite-scroll-container").each(function () {
        var t = $(this);
        new WanderersCollectionPage(t.attr("data-collection-handle"), t).fetchInitial();
    }),
    $(document).ready(function () {
        $("[data-swatch]").each(function (t, e) {
            $(this).find("[data-swatch-value]");
        });

        $(document).on("click", "[data-swatch-value]", function (t) {
            var e = $(this);
            e.hasClass("available") && e.attr("data-variant-url") && (window.location = e.attr("data-variant-url"));
        });

        if (Shopify.GWP_PROMO) {
            var tier_two_high_price =   window.promotiers.highestPrice[0]['tier2'];
            var tier_three_high_price =   window.promotiers.highestPrice[0]['tier3'];
            $('[data-tier2]').attr('data-money', tier_two_high_price).html(moneyFormat(tier_two_high_price));
            $('[data-tier3]').attr('data-money', tier_three_high_price).html(moneyFormat(tier_three_high_price));
        }
        window.Currency.updatePrices()

    }),
    $(document).on("change", '[name="id"]', function () {
        var t = $(this);
        $("[data-lowstock]").attr("data-current-variant", t.val()), updateLowStock();
    }),
    $(document).on("change", function () {
        setTimeout(function () {
            var t = $("[data-product-select] option:selected").val();
            $("#sticky-id").val(t);
        }, 200);
    }),
    (window.Currency = window.Currency || {}),
    (window.Currency.formatMoney = function (t, e) {
        function o(t, e) {
            return void 0 === t ? e : t;
        }
        function a(t, e, a, n) {
            if (((e = o(e, 2)), (a = o(a, ",")), (n = o(n, ".")), isNaN(t) || null == t)) return 0;
            var i = (t = (t / 100).toFixed(e)).split(".");
            return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (i[1] ? n + i[1] : "");
        }
        if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(t, e);
        "string" == typeof t && (t = t.replace(".", ""));
        var n = "",
            i = /\{\{\s*(\w+)\s*\}\}/,
            r = e || "${{amount}}";
        switch (r.match(i)[1]) {
            case "amount":
                n = a(t, 2);
                break;
            case "amount_no_decimals":
                n = a(t, 0);
                break;
            case "amount_with_comma_separator":
                n = a(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = a(t, 0, ".", ",");
        }
        return r.replace(i, n);
    });
var ALLOWED_CURR = ['USD', 'CAD', 'NZD', 'AUD'];
(window.Currency = window.Currency || {}),
    (window.Currency.moneyFormats = window.Currency.moneyFormats || {
        USD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD" },
        EUR: { money_format: "&euro;{{amount}}", money_with_currency_format: "&euro;{{amount}} EUR" },
        GBP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP" },
        CAD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD" },
        ALL: { money_format: "Lek {{amount}}", money_with_currency_format: "Lek {{amount}} ALL" },
        DZD: { money_format: "DA {{amount}}", money_with_currency_format: "DA {{amount}} DZD" },
        AOA: { money_format: "Kz{{amount}}", money_with_currency_format: "Kz{{amount}} AOA" },
        ARS: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} ARS" },
        AMD: { money_format: "{{amount}} AMD", money_with_currency_format: "{{amount}} AMD" },
        AWG: { money_format: "Afl{{amount}}", money_with_currency_format: "Afl{{amount}} AWG" },
        AUD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD" },
        BBD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} Bds" },
        AZN: { money_format: "m.{{amount}}", money_with_currency_format: "m.{{amount}} AZN" },
        BDT: { money_format: "Tk {{amount}}", money_with_currency_format: "Tk {{amount}} BDT" },
        BSD: { money_format: "BS${{amount}}", money_with_currency_format: "BS${{amount}} BSD" },
        BHD: { money_format: "{{amount}}0 BD", money_with_currency_format: "{{amount}}0 BHD" },
        BYR: { money_format: "Br {{amount}}", money_with_currency_format: "Br {{amount}} BYR" },
        BZD: { money_format: "BZ${{amount}}", money_with_currency_format: "BZ${{amount}} BZD" },
        BTN: { money_format: "Nu {{amount}}", money_with_currency_format: "Nu {{amount}} BTN" },
        BAM: { money_format: "KM {{amount_with_comma_separator}}", money_with_currency_format: "KM {{amount_with_comma_separator}} BAM" },
        BRL: { money_format: "R$ {{amount_with_comma_separator}}", money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL" },
        BOB: { money_format: "Bs{{amount_with_comma_separator}}", money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB" },
        BWP: { money_format: "P{{amount}}", money_with_currency_format: "P{{amount}} BWP" },
        BND: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} BND" },
        BGN: { money_format: "{{amount}} лв", money_with_currency_format: "{{amount}} лв BGN" },
        MMK: { money_format: "K{{amount}}", money_with_currency_format: "K{{amount}} MMK" },
        KHR: { money_format: "KHR{{amount}}", money_with_currency_format: "KHR{{amount}}" },
        KYD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} KYD" },
        XAF: { money_format: "FCFA{{amount}}", money_with_currency_format: "FCFA{{amount}} XAF" },
        CLP: { money_format: "${{amount_no_decimals}}", money_with_currency_format: "${{amount_no_decimals}} CLP" },
        CNY: { money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY" },
        COP: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} COP" },
        CRC: { money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC" },
        HRK: { money_format: "{{amount_with_comma_separator}} kn", money_with_currency_format: "{{amount_with_comma_separator}} kn HRK" },
        CZK: { money_format: "{{amount_with_comma_separator}} K&#269;", money_with_currency_format: "{{amount_with_comma_separator}} K&#269;" },
        DKK: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "kr.{{amount_with_comma_separator}}" },
        DOP: { money_format: "RD$ {{amount}}", money_with_currency_format: "RD$ {{amount}}" },
        XCD: { money_format: "${{amount}}", money_with_currency_format: "EC${{amount}}" },
        EGP: { money_format: "LE {{amount}}", money_with_currency_format: "LE {{amount}} EGP" },
        ETB: { money_format: "Br{{amount}}", money_with_currency_format: "Br{{amount}} ETB" },
        XPF: { money_format: "{{amount_no_decimals_with_comma_separator}} XPF", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF" },
        FJD: { money_format: "${{amount}}", money_with_currency_format: "FJ${{amount}}" },
        GMD: { money_format: "D {{amount}}", money_with_currency_format: "D {{amount}} GMD" },
        GHS: { money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}" },
        GTQ: { money_format: "Q{{amount}}", money_with_currency_format: "{{amount}} GTQ" },
        GYD: { money_format: "G${{amount}}", money_with_currency_format: "${{amount}} GYD" },
        GEL: { money_format: "{{amount}} GEL", money_with_currency_format: "{{amount}} GEL" },
        HNL: { money_format: "L {{amount}}", money_with_currency_format: "L {{amount}} HNL" },
        HKD: { money_format: "${{amount}}", money_with_currency_format: "HK${{amount}}" },
        HUF: { money_format: "{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft" },
        ISK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr ISK" },
        INR: { money_format: "Rs. {{amount}}", money_with_currency_format: "Rs. {{amount}}" },
        IDR: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "Rp {{amount_with_comma_separator}}" },
        ILS: { money_format: "{{amount}} NIS", money_with_currency_format: "{{amount}} NIS" },
        JMD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} JMD" },
        JPY: { money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY" },
        JEP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP" },
        JOD: { money_format: "{{amount}}0 JD", money_with_currency_format: "{{amount}}0 JOD" },
        KZT: { money_format: "{{amount}} KZT", money_with_currency_format: "{{amount}} KZT" },
        KES: { money_format: "KSh{{amount}}", money_with_currency_format: "KSh{{amount}}" },
        KWD: { money_format: "{{amount}}0 KD", money_with_currency_format: "{{amount}}0 KWD" },
        KGS: { money_format: "лв{{amount}}", money_with_currency_format: "лв{{amount}}" },
        LVL: { money_format: "Ls {{amount}}", money_with_currency_format: "Ls {{amount}} LVL" },
        LBP: { money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP" },
        LTL: { money_format: "{{amount}} Lt", money_with_currency_format: "{{amount}} Lt" },
        MGA: { money_format: "Ar {{amount}}", money_with_currency_format: "Ar {{amount}} MGA" },
        MKD: { money_format: "ден {{amount}}", money_with_currency_format: "ден {{amount}} MKD" },
        MOP: { money_format: "MOP${{amount}}", money_with_currency_format: "MOP${{amount}}" },
        MVR: { money_format: "Rf{{amount}}", money_with_currency_format: "Rf{{amount}} MRf" },
        MXN: { money_format: "$ {{amount}}", money_with_currency_format: "$ {{amount}} MXN" },
        MYR: { money_format: "RM{{amount}} MYR", money_with_currency_format: "RM{{amount}} MYR" },
        MUR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} MUR" },
        MDL: { money_format: "{{amount}} MDL", money_with_currency_format: "{{amount}} MDL" },
        MAD: { money_format: "{{amount}} dh", money_with_currency_format: "Dh {{amount}} MAD" },
        MNT: { money_format: "{{amount_no_decimals}} &#8366", money_with_currency_format: "{{amount_no_decimals}} MNT" },
        MZN: { money_format: "{{amount}} Mt", money_with_currency_format: "Mt {{amount}} MZN" },
        NAD: { money_format: "N${{amount}}", money_with_currency_format: "N${{amount}} NAD" },
        NPR: { money_format: "Rs{{amount}}", money_with_currency_format: "Rs{{amount}} NPR" },
        ANG: { money_format: "&fnof;{{amount}}", money_with_currency_format: "{{amount}} NA&fnof;" },
        NZD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD" },
        NIO: { money_format: "C${{amount}}", money_with_currency_format: "C${{amount}} NIO" },
        NGN: { money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN" },
        NOK: { money_format: "kr {{amount_with_comma_separator}}", money_with_currency_format: "kr {{amount_with_comma_separator}} NOK" },
        OMR: { money_format: "{{amount_with_comma_separator}} OMR", money_with_currency_format: "{{amount_with_comma_separator}} OMR" },
        PKR: { money_format: "Rs.{{amount}}", money_with_currency_format: "Rs.{{amount}} PKR" },
        PGK: { money_format: "K {{amount}}", money_with_currency_format: "K {{amount}} PGK" },
        PYG: { money_format: "Gs. {{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG" },
        PEN: { money_format: "S/. {{amount}}", money_with_currency_format: "S/. {{amount}} PEN" },
        PHP: { money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP" },
        PLN: { money_format: "{{amount_with_comma_separator}} zl", money_with_currency_format: "{{amount_with_comma_separator}} zl PLN" },
        QAR: { money_format: "QAR {{amount_with_comma_separator}}", money_with_currency_format: "QAR {{amount_with_comma_separator}}" },
        RON: { money_format: "{{amount_with_comma_separator}} lei", money_with_currency_format: "{{amount_with_comma_separator}} lei RON" },
        RUB: { money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB" },
        RWF: { money_format: "{{amount_no_decimals}} RF", money_with_currency_format: "{{amount_no_decimals}} RWF" },
        WST: { money_format: "WS$ {{amount}}", money_with_currency_format: "WS$ {{amount}} WST" },
        SAR: { money_format: "{{amount}} SR", money_with_currency_format: "{{amount}} SAR" },
        STD: { money_format: "Db {{amount}}", money_with_currency_format: "Db {{amount}} STD" },
        RSD: { money_format: "{{amount}} RSD", money_with_currency_format: "{{amount}} RSD" },
        SCR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} SCR" },
        SGD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} SGD" },
        SYP: { money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP" },
        ZAR: { money_format: "R {{amount}}", money_with_currency_format: "R {{amount}} ZAR" },
        KRW: { money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW" },
        LKR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} LKR" },
        SEK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr SEK" },
        CHF: { money_format: "SFr. {{amount}}", money_with_currency_format: "SFr. {{amount}} CHF" },
        TWD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TWD" },
        THB: { money_format: "{{amount}} &#xe3f;", money_with_currency_format: "{{amount}} &#xe3f; THB" },
        TZS: { money_format: "{{amount}} TZS", money_with_currency_format: "{{amount}} TZS" },
        TTD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TTD" },
        TND: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} DT" },
        TRY: { money_format: "{{amount}}TL", money_with_currency_format: "{{amount}}TL" },
        UGX: { money_format: "Ush {{amount_no_decimals}}", money_with_currency_format: "Ush {{amount_no_decimals}} UGX" },
        UAH: { money_format: "₴{{amount}}", money_with_currency_format: "₴{{amount}} UAH" },
        AED: { money_format: "Dhs. {{amount}}", money_with_currency_format: "Dhs. {{amount}} AED" },
        UYU: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} UYU" },
        VUV: { money_format: "${{amount}}", money_with_currency_format: "${{amount}}VT" },
        VEF: { money_format: "Bs. {{amount_with_comma_separator}}", money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF" },
        VND: { money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND" },
        XBT: { money_format: "{{amount_no_decimals}} BTC", money_with_currency_format: "{{amount_no_decimals}} BTC" },
        XOF: { money_format: "CFA{{amount}}", money_with_currency_format: "CFA{{amount}} XOF" },
        ZMW: { money_format: "K{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}" },
    }),
    (window.Currency.convertedFormat =
        window.Currency.convertedFormat ||
        (function (t) {
            for (var e = Object.keys(t), o = 0; o < e.length; o++) if (t[e[o]] == window.Currency.format) return e[o];
            return "money_format";
        })(window.Currency.moneyFormats[window.Currency.currency])),
    (window.Currency.updatePrices =
        window.Currency.updatePrices ||
        function (t) {
            var e = window.Currency.currentCurrency || window.Currency.currency,
                o = window.Currency.moneyFormats[e][window.Currency.convertedFormat];
            $("[data-currency]").each(function () {
                var t,
                    a = $(this),
                    n = a.attr("data-money"),
                    gwp = a.attr('data-gwp-price'),
                    is_gwp = false;
                if (typeof gwp !== 'undefined' && gwp !== false) {
                    is_gwp = true;
                }
                n &&
                    void 0 !== window.Currency.convert &&
                    ((t = e == window.Currency.currency ? n : window.Currency.convert(n, window.Currency.currency, e)),
                    ALLOWED_CURR.indexOf(e) >= 0 && (a.hasClass("cart-subtotal-value") || a.hasClass("product-price-value")) ? a.html('<span class="currency-name">' + e + "</span>" + window.Currency.formatMoney(t, o)) : a.html(is_gwp ? window.Currency.formatMoney(t, o).replace('.00', '') : window.Currency.formatMoney(t, o)));
            });
        });
var CURRENCY_COOKIE_NAME = "currency";
function addCurrencyListener() {
    $(document).on("onCurrencyChange", function (t, e) {
        if (void 0 !== e && void 0 !== window.Currency.moneyFormats && void 0 !== window.Currency.moneyFormats[e]) {
            (window.Currency.currentCurrency = e),
                window.Currency.moneyFormats[e],
                $("[data-currency-selector]").val(e),
                "undefined" != typeof Cookies ? Cookies.set(CURRENCY_COOKIE_NAME, e) : "undefined" !== $.cookie && $.cookie(CURRENCY_COOKIE_NAME, e);
            var o = window.Currency.moneyFormats[e][window.Currency.convertedFormat];
            $("[data-currency]").each(function () {
                var t, a = $(this),
                n = a.data("money"),
                gwp = a.attr('data-gwp-price'),
                is_gwp = false;
            if (typeof gwp !== 'undefined' && gwp !== false) {
                is_gwp = true;
            }
                n &&
                    void 0 !== window.Currency.convert &&
                    ((t = e == window.Currency.currency ? n : window.Currency.convert(n, window.Currency.currency, e)),
                    ALLOWED_CURR.indexOf(e) >= 0 && (a.hasClass("cart-subtotal-value") || a.hasClass("product-price-value")) ? a.html('<span class="currency-name">' + e + "</span>" + window.Currency.formatMoney(t, o)) : a.html(is_gwp ? window.Currency.formatMoney(t, o).replace('.00','') : window.Currency.formatMoney(t, o)));
            });
        }
    }),
        $(document).on("change", '[name="id"]', function (t) { });
}
function checkCurrencyCookie() {
    if ("undefined" != typeof Cookies && Cookies.get(CURRENCY_COOKIE_NAME)) {
        var t = Cookies.get(CURRENCY_COOKIE_NAME);
        $(document).trigger("onCurrencyChange", t);
    } else void 0 !== $.cookie && $.cookie(CURRENCY_COOKIE_NAME) && ((t = $.cookie(CURRENCY_COOKIE_NAME)), $(document).trigger("onCurrencyChange", t));
}
function updateBackInStockButton() {
    if ("undefined" != typeof BIS && BIS.urlIsProductPage()) {
        var t = $("[data-back-in-stock]");
        t.text() != BIS.Config.button.caption && t.text(BIS.Config.button.caption);
        var e = document.getElementById("oos_variant_id_select").value,
            o = BIS.popup._variantsById[e];
        void 0 !== o && (BIS.popup.variantIsUnavailable(o) ? t.attr('style','') : t.hide()), $(".bis-button").hide();
    }
}
function Accordion(t) {
    (this.container = t),
        (this.id = (window.accordions = window.accordions || []).length),
        this.container.attr("data-id", this.id),
        (this.slides = this.container.find("[data-accordion-slide]")),
        (this.multiple = this.container.data("multiple") || !1),
        this.slides.each(function (t) {
            var e = $(this);
            e.attr("data-id", t), e.find("[data-accordion-title]").attr("data-id", t);
        }),
        this.container.on("click", "[data-accordion-title]", this.changeSlide.bind(this));
}
$(document).on("change", "[data-currency-selector]", function (t) {
    var e = $(this),
        o = e.val();
    e.trigger("onCurrencyChange", o);
}),
    $(document).ready(function () {
        addCurrencyListener(), checkCurrencyCookie();
    }),
    addCurrencyListener(),
    updateBackInStockButton(),
    $(document).ready(updateBackInStockButton),
    "undefined" != typeof BIS && BIS.popup.ready.then(updateBackInStockButton),
    setInterval(updateBackInStockButton, 50),
    $(document).on("change", '[name="id"]', updateBackInStockButton),
    $(document).on("click touchstart", updateBackInStockButton),
    $(document).on("click touchstart", "[data-show-back-in-stock]", function (t) {
        if ((t.preventDefault(), t.stopPropagation(), "undefined" == typeof BIS)) return console.log("Back in Stock App not found!");
        var e = document.getElementById("oos_variant_id_select").value,
            o = BIS.popup._variantsById[e];
        void 0 !== o && BIS.popup.variantIsUnavailable(o) && (BISPopover.form.selectVariant(e), BISPopover.show());
    }),
    (Accordion.prototype = {
        changeSlide: function (t, e) {
            if ("undefined" !== this.container) {
                var o = $(t.currentTarget).data("id");
                void 0 !== o && this.setSlide(o);
            }
        },
        getSlideByIndex: function (t) {
            return this.container.find('[data-accordion-slide][data-id="' + t + '"]');
        },
        setSlide: function (t) {
            var e = this.getSlideByIndex(t);
            "true" == e.attr("data-expanded")
                ? (e.removeClass("is-expanded"), e.attr("data-expanded", !1))
                : (this.multiple || (this.slides.removeClass("is-expanded"), this.slides.attr("data-expanded", !1)), e.addClass("is-expanded"), e.attr("data-expanded", !0)),
                this.onExpand(t, e);
        },
        onExpand: function (t, e) { },
    }),
    $(document).ready(function () {
        $("[data-accordion]").each(function () {
            var t = new Accordion($(this));
            (window.accordions = window.accordions || []), window.accordions.push(t);
        });
    });
var GEO_CACHE_COOKIE_NAME = "GeoDataCache";
function geoTools() {
    if (((this.callbacks = []), "undefined" != typeof Cookies && "function" == typeof Cookies.get)) {
        var t = Cookies.get(GEO_CACHE_COOKIE_NAME);
        if ("string" == typeof t)
            try {
                t = JSON.parse(t);
            } catch (t) {
                return void console.error(t);
            }
        this.geoData = t;
    }
}
(geoTools.prototype = {
    fetchGeo: function (t) {
        if (void 0 !== this.geoData) return this.callbacks.push(t), t(this.geoData);
        this.callbacks.push(t), void 0 === this.geoFetch && (this.geoFetch = $.getJSON("//ipapi.co/json/?key=9cfdf7e5302b1c8a09c278ec009656bf67f94560", this.onGeoFetched.bind(this)));
    },
    onGeoError: function (t) {
        console.log(t);
    },
    onGeoFetched: function (t) {
        this.geoData = t;
        for (var e = 0; e < this.callbacks.length; e++) this.callbacks[e](t);
        $(document).trigger("onGeo", t), "undefined" != typeof Cookies && "function" == typeof Cookies.set && Cookies.set(GEO_CACHE_COOKIE_NAME, t, { expires: 1 });
    },
}),
    (window.Geo = new geoTools());
var DEFAULT_INSTAGRAM_TEMPLATE = '<div class="c-instagram__photo-container"><a href="{{link}}" target="_blank" class="c-instagram__photo">';
(DEFAULT_INSTAGRAM_TEMPLATE += '<img src="{{image}}" />'), (DEFAULT_INSTAGRAM_TEMPLATE += "</a></div>");
var DEFAULT_INSTAGRAM_OPTIONS = { get: "user", template: DEFAULT_INSTAGRAM_TEMPLATE, resolution: "low_resolution" };
function instagram(t) {
    if (!t.hasClass("is-running")) {
        var e = t.data("token");
        if (e && e.length) {
            var o = e.split(".");
            if (o.length) {
                var a = JSON.parse(JSON.stringify(DEFAULT_INSTAGRAM_OPTIONS));
                (a.userId = o[0]), (a.accessToken = e), (a.target = t.attr("id")), (a.limit = t.data("limit") || 6), new Instafeed(a).run();
            }
        }
    }
}
function BlogTemplate(t) {
    if (
        ((this.container = t),
            (this.articleContainer = t.find("[data-article-container]")),
            (this.perPage = parseInt(this.container.attr("data-blog-template-per-page")) || 4),
            (this.viewMore = this.container.find("[data-blog-template-load-more]")),
            (this.page = 1),
            (this.pendingRequest = null),
            (this.existingData = t.find("[data-blog-json]")),
            this.existingData.length)
    ) {
        var e = this.existingData.html();
        try {
            e = JSON.parse(e);
        } catch (t) {
            return void console.error(t);
        }
        this.parseJSON(e, this.page || 1);
    }
    this.container.on("click touchstart", "[data-blog-template-load-more]", this.fetchNext.bind(this));
}
function CollectionCarousel(t) {
    (this.container = t),
        (this.options = {
            infinite: !0,
            mobileFirst: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: !1,
            dots: !1,
            arrows: !1,
            adapativeHeight: !0,
            cssEase: "cubic-bezier(0.23, 1, 0.32, 1)",
            responsive: [
                { breakpoint: 500, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                { breakpoint: 750, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                { breakpoint: 1e3, settings: { slidesToShow: 4, slidesToScroll: 4 } },
            ],
        }),
        (this.carousel = this.container.find("[data-collection-carousel-carousel]")),
        (this.slick = this.carousel.slick(this.options));
}
function updateCart() {
    $(".edit-quant").click(function (t) {
        t.preventDefault();
        var e = $(this),
            o = e.attr("data-compare-price"),
            a = $(".cart-count"),
            n = $(".cart-edit-modal"),
            i = JSON.parse($(e.data("item")).html()),
            r = e.attr("data-inventory_quantity"),
            c = e.attr("data-inventory_policy"),
            s = e.data("line"),
            l =
                '        <table>        <tbody>        <tr>        <td>        <a href="' +
                i.url +
                '">        <img src="' +
                i.image +
                '" alt="' +
                i.title +
                '">        </a>        </td>        <td class="item-content">        <a href="' +
                i.url +
                '">        <h4 class="item-title" >' +
                i.product_title +
                "</h4>        </a>";
        null !== i.variant_title && "Default" != i.variant_title && (l = l + '<p class="cart__variant">' + i.variant_title + "</p>"),
            (l =
                l +
                '<div class="cart__item-subtotal index-1">        <span '+(o && o > i.original_price ? ' class="sale-final-price"' : '')+' style="padding-right:10px" data-currency="" data-money="' +
                i.price +
                '">' +
                moneyFormat(i.price) +
                "</span>" +
                (o && o > i.original_price ? '<s data-currency data-money="' + o + '">' + moneyFormat(o) + "</s>" : "") +
                '        </div>        <div class="quant-box" style="display:flex">        <label><strong>Quantity:</strong></label>        <div class="cart__quantity-controller">        <span data-inventory_quantity="' +
                r +
                '" data-inventory_policy="' +
                c +
                '" class="ss-icon product-minus js-change-quantity" data-func="minus">        <span class="icon-minus"></span>        </span>        <input type="number" class="quantity" aria-label="Item quantity" id="update-quant" min="0" value="' +
                i.quantity +
                '"/>        <span data-inventory_quantity="' +
                r +
                '" data-inventory_policy="' +
                c +
                '" class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>        </div>        </div>        <div class="item-total">        <label><strong>Total:</strong></label>        <span data-currency="" data-money="' +
                i.final_line_price +
                '">' +
                moneyFormat(i.final_line_price) +
                "</span>        </div>        </td>        </tr>        </tbody>        </table>"),
            $("#edit-modal-item").html(l),
            n.fadeIn(),
            $("html").addClass("modal-open"),
            $(".top-menu__close__button").click(function () {
                n.fadeOut(), $("html").removeClass("modal-open");
            }),
            $("#update-quant").unbind("change"),
            $("#update-quant").on("change", function () {
                var t = $(this).val() * i.price;
                $(".item-total span").attr("data-money", t).html(moneyFormat(t));
            }),
            $(".update-btn").unbind("click"),
            $(".update-btn").click(function () {
                var t = this;
                $(this).addClass("pseudo-loading"), i.variant_id;
				var o = $("#update-quant").val(),
				gwp = '#free-gwp-wrapper';
                $.ajax({
                    url: "/cart/change.js",
                    data: { line: s, quantity: o },
                    type: "post",
                    dataType: "json",
                    success: function (i) {
                        a.text(i.item_count);
                        var r = i;
                        Shopify.getCartHtml(function (a) {
                            $(Shopify.GWP).html($(a).find(Shopify.GWP).html());
								if ($(a).find(gwp).length) {
									$(gwp).html($(a).find(gwp).html());
								}else{
									$('#free-barca').remove();
								}
								$("#main-cart").html($(a).find("#main-cart").html()),
                                warnBeforeCheckout(),
                                promoSlick(),
                                promoFreeGiftSlick(),
                                0 == r.item_count && $("#shopify-section-related-products").remove(),
                                window.Currency.updatePrices(),
                                refreshCartContent(r),
                                $(window).width() > 767 && $("table.cart__table thead").removeClass("small--hide"),
                                e.parents(".cart__quantity-controller").find("input.quantity").val(o),
                                n.fadeOut(),
                                $("html").removeClass("modal-open"),
                                $(t).removeClass("pseudo-loading"),
                                updateCart();
                        })
                    },
                });
            });
    });
}
function moneyFormat(t, e) {
    var o,
        a = window.Currency.currentCurrency || window.Currency.currency,
        n = window.Currency.moneyFormats[a][window.Currency.convertedFormat];
    if (!isNaN(t) && void 0 !== window.Currency.convert) return (o = a == window.Currency.currency ? t : window.Currency.convert(t, window.Currency.currency, a)), (e ? a + " " : "") + utfDecode(window.Currency.formatMoney(o, n));
}
function defaultFormat(t) {
    var e = window.Currency.currency || window.Currency.currentCurrency,
        o = (window.Currency.moneyFormats[e][window.Currency.convertedFormat], "undefined" != typeof Cookies && Cookies.get(CURRENCY_COOKIE_NAME) ? Cookies.get(CURRENCY_COOKIE_NAME) : e);
    return window.Currency.convert(t, o, e);
}
function isCurrencyDefault() {
    var t = window.Currency.currency || window.Currency.currentCurrency;
    window.Currency.moneyFormats[t][window.Currency.convertedFormat];
    return ("undefined" != typeof Cookies && Cookies.get(CURRENCY_COOKIE_NAME) ? Cookies.get(CURRENCY_COOKIE_NAME) : t) == t;
}
function utfDecode(t) {
    return new DOMParser().parseFromString("<!doctype html><body>" + t, "text/html").body.textContent;
}
function promoSlick() {
    if ($(window).width() > 1023) {
        if ($(".gwp-slider .overflow-slider").hasClass("slick-initialized")) return !1;
        $(".gwp-slider .overflow-slider").slick({
            dots: !1,
            infinite: !1,
            arrows: !0,
            cssEase: "linear",
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: !1,
            prevArrow: '<img class="control-c slick-prev" src="' + theme.left_arrow + '">',
            nextArrow: '<img class="control-c slick-next" src="' + theme.right_arrow + '">',
            responsive: [{ breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: !1, dots: !1, cssEase: "linear" } }],
        });
    } else $(".gwp-slider .overflow-slider").hasClass("slick-initialized") && $(".gwp-slider .overflow-slider").slick("destroy");
}
$(document).ready(function(){
    promoSlick();
    if(Shopify.GWP_PROMO && window.template == 'product'){
        changeCTAMothersDay($('[data-add-to-cart]:not(.btn--preorder,.bis-btn)'));
    }
});
function promoFreeGiftSlick() {
    if ($(window).width() > 767) {
        if ($("#gwp-product-carousal").hasClass("slick-initialized")) return !1;
        $("#gwp-product-carousal").slick({
            dots: !1,
            infinite: !1,
            arrows: !0,
            cssEase: "linear",
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: !1,
            prevArrow: '<img class="control-c slick-prev" src="' + theme.left_arrow + '">',
            nextArrow: '<img class="control-c slick-next" src="' + theme.right_arrow + '">',
            responsive: [{ breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: !1, dots: !1, cssEase: "linear" } }],
        });
    } else $("#gwp-product-carousal").hasClass("slick-initialized") && $("#gwp-product-carousal").slick("destroy");
}
function saleSliderInit() {
    saleSlider(),
        $(window).resize(function () {
            saleSlider();
        });
}
function saleSlider() {
    var t = $(window).width();
    if (0 != $(".sale-product-carousal").length) {
        var e = $(".sale-product-carousal").data("target");
        if (t > 1023) {
            if (($(e).removeClass("grid-overflow-wrapper"), $(e).find(".aos-animate").removeClass("grid grid--uniform"), $(".sale-product-carousal").hasClass("slick-initialized"))) return !1;
            $(".sale-product-carousal").slick({
                dots: !1,
                infinite: !1,
                arrows: !0,
                cssEase: "linear",
                slidesToShow: 5,
                slidesToScroll: 5,
                autoplay: !1,
                prevArrow: '<div class="control-c slick-prev"><img src="' + theme.left_arrow + '"></div>',
                nextArrow: '<div class="control-c slick-next"><img src="' + theme.right_arrow + '"></div>',
                responsive: [
                    { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: !1, dots: !1, cssEase: "linear" } },
                    { breakpoint: 1440, settings: { slidesToShow: 4, slidesToScroll: 4, infinite: !1, dots: !1, cssEase: "linear" } },
                ],
            });
        } else $(".sale-product-carousal").hasClass("slick-initialized") && ($(".sale-product-carousal").slick("destroy"), $(e).addClass("grid-overflow-wrapper"), $(e).find(".aos-animate").addClass("grid grid--uniform"));
    }
}
function relatedSliderInit() {
    relatedSlider(),
        $(window).resize(function () {
            relatedSlider();
        });
}
function relatedSlider() {
    var t = $(window).width();
    if (0 != $("#related-product-carousal").length) {
        var e = $("#related-product-carousal").data("target");
        if (window.location.href.indexOf("/cart") > -1) {
            if (t > 849) {
                if (($(e).removeClass("grid-overflow-wrapper"), $(e).find(".aos-animate").removeClass("grid grid--uniform"), $("#related-product-carousal").hasClass("slick-initialized"))) return !1;
                $("#related-product-carousal").slick({
                    dots: !1,
                    infinite: !1,
                    arrows: !0,
                    cssEase: "linear",
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    autoplay: !1,
                    prevArrow: '<div class="control-c slick-prev"><img src="' + theme.left_arrow + '"/></div>',
                    nextArrow: '<div class="control-c slick-next"><img src="' + theme.right_arrow + '"/></div>',
                    responsive: [
                        { breakpoint: 1023, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: !1, dots: !1, cssEase: "linear" } },
                        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: !1, dots: !1, cssEase: "linear" } },
                        { breakpoint: 1440, settings: { slidesToShow: 4, slidesToScroll: 4, infinite: !1, dots: !1, cssEase: "linear" } },
                    ],
                });
            } else $("#related-product-carousal").hasClass("slick-initialized") && ($("#related-product-carousal").slick("destroy"), $(e).addClass("grid-overflow-wrapper"), $(e).find(".aos-animate").addClass("grid grid--uniform"));
        }else{
            if (t > 1023) {
                if (($(e).removeClass("grid-overflow-wrapper"), $(e).find(".aos-animate").removeClass("grid grid--uniform"), $("#related-product-carousal").hasClass("slick-initialized"))) return !1;
                $("#related-product-carousal").slick({
                    dots: !1,
                    infinite: !1,
                    arrows: !0,
                    cssEase: "linear",
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    autoplay: !1,
                    prevArrow: '<div class="control-c slick-prev"><img src="' + theme.left_arrow + '"/></div>',
                    nextArrow: '<div class="control-c slick-next"><img src="' + theme.right_arrow + '"/></div>',
                    responsive: [
                        { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4, infinite: !1, dots: !1, cssEase: "linear" } },
                        { breakpoint: 1440, settings: { slidesToShow: 5, slidesToScroll: 5, infinite: !1, dots: !1, cssEase: "linear" } },
                    ],
                });
            } else $("#related-product-carousal").hasClass("slick-initialized") && ($("#related-product-carousal").slick("destroy"), $(e).addClass("grid-overflow-wrapper"), $(e).find(".aos-animate").addClass("grid grid--uniform"));
        }
        // if ($("#related-product-carousal").find('.slick-track').children().length == 0) {
        //     $('#related-slick').parent().hide();
        // }
    }
}
function ProductRecommendations() {
    var $container = $("[data-section-id='product-recommendations']");
    var baseUrl = $container.data('baseUrl');
    var productId = $container.data('productId');
    var limit = $container.data('limit');
    var section_id = 'product-recommendations';
    if (window.location.href.indexOf("/cart") > -1) {
        section_id = 'product-recommendations-cart';
        var cartItemIdObject = JSON.parse(document.getElementById('cartProductIdsJson').innerHTML);
        productId = cartItemIdObject.item_id;
    }
    var productRecommendationsUrlAndContainerClass = baseUrl + '?section_id='+section_id+'&limit=' + limit +
    '&product_id=' +productId +
    ' .product-recommendations';
    $container.parent().load(productRecommendationsUrlAndContainerClass,function(){
        setTimeout(function(){
            relatedSlider();
        },100);
    });
}
function homeSliderInit() {
    homeSlider()
    $(window).resize(function () {
        homeSlider();
    });
}
function homeSlider() {
    var t = $(window).width();
    if (0 != $("#home-product-carousal").length) {
        var e = $("#home-product-carousal").data("target");
        if (t > 1023) {
            if (($(e).removeClass("grid-overflow-wrapper"), $(e).find(".aos-animate").removeClass("grid grid--uniform"), $("#home-product-carousal").hasClass("slick-initialized"))) return !1;
            $("#home-product-carousal").slick({
                dots: !1,
                infinite: !1,
                arrows: !0,
                cssEase: "linear",
                slidesToShow: 6,
                slidesToScroll: 6,
                autoplay: !1,
                prevArrow: '<div class="control-c slick-prev"><img src="' + theme.left_arrow + '"/></div>',
                nextArrow: '<div class="control-c slick-next"><img src="' + theme.right_arrow + '"/></div>',
                responsive: [
                    { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 4, infinite: !1, dots: !1, cssEase: "linear" } },
                    { breakpoint: 1440, settings: { slidesToShow: 5, slidesToScroll: 5, infinite: !1, dots: !1, cssEase: "linear" } },
                ],
            });
        } else $("#home-product-carousal").hasClass("slick-initialized") && ($("#home-product-carousal").slick("destroy"), $(e).addClass("grid-overflow-wrapper"), $(e).find(".aos-animate").addClass("grid grid--uniform"));
    }
}

    $(document).ready(function () {
        $("[data-instagram-feed]").each(function () {
            instagram($(this));
        });
    }),
    $(document).on("shopify:section:load", ".c-section__instagram", function (t) {
        var e = t.detail.sectionId;
        instagram($('[data-instagram-feed][data-feed-id="' + e + '"]'));
    }),
    $(document).on("shopify:section:unload", ".c-section__instagram", function (t) {
        var e = t.detail.sectionId,
            o = $('[data-instagram-feed][data-feed-id="' + e + '"]');
        o.hasClass("is-running") && o.remove();
    }),
    $(document).on("shopify:section:select", ".c-section__instagram", function (t) {
        t.detail.sectionId;
    }),
    (BlogTemplate.prototype = {
        getBaseURL: function () {
            window.location.pathname;
        },
        fetchNext: function (t) {
            t.preventDefault(), t.stopPropagation(), this.fetchPage(this.page + 1);
        },
        isPrinted: function (t) {
            return this.container.find('[data-article-id="' + t + '"]').length;
        },
        fetchPage: function (t) {
            if (!(t <= 0) && null == this.pendingRequest) {
                var e = { view: "json", page: t },
                    o = { template: this, params: e },
                    a = $.ajax({ url: this.getBaseURL(), data: e, method: "GET", error: this.onError.bind(o), success: this.onData.bind(o) });
                (o.request = a), (this.pendingRequest = a);
            }
        },
        onError: function (t, e, o) {
            (this.pendingRequest = null), console.error(t), console.error(e), console.error(o);
        },
        onData: function (t) {
            (this.template.pendingRequest = null), (this.dataRaw = t), (this.data = JSON.parse(t)), this.template.parseJSON(this.data, this.params.page);
        },
        parseJSON: function (t, e) {
            (this.data = t.blog), (this.page = e);
            for (var o = 0; o < t.articles.length; o++) {
                var a = t.articles[o];
                this.isPrinted(a.id) || this.articleContainer.append(a.data);
            }
            t.articles.length < this.perPage && this.onArticlesFetched();
        },
        onArticlesFetched: function () {
            this.viewMore.css("display", "none");
        },
    }),
    (window.blogTemplate = []),
    $(document).ready(function () {
        $("[data-blog-template]").each(function (t, e) {
            var o = new BlogTemplate($(this));
            window.blogTemplate.push(o), (window.blogTemplateLast = o);
        });
    }),
    (CollectionCarousel.prototype = Object.assign(CollectionCarousel.prototype, {})),

    
    $(document).ready(function() {

        function t() {
            $(window).width() > 767 ? $(".cart__table thead").removeClass("small--hide") : $(".cart__table thead").addClass("small--hide");
        }
        $("[data-collection-carousel]").each(function (t, e) {
            new CollectionCarousel($(e));
        }),
        $(".hasChild").click(function () {
            var t = $(this).children(".submenu");
            $(".submenu").not(t).parent().removeClass("side-left-menu-open"),$(".submenu").not(t).parent().prev().removeClass("previous-of-menu-open"), $(this).toggleClass("side-left-menu-open"),$(this).prev().toggleClass("previous-of-menu-open"), $(".submenu").not(t).hide("slow"), $(this).children(".submenu").slideToggle();
        }),
        $("html").click(function () {
            var dataScrolled = $('html,body').attr('data-scrolled');
            $(".menu-overlay-fixed").fadeOut(300), $("#menu-toggle").html("&#9776;");
            $("html,body").removeClass("menu-open").removeAttr('style');
            $("html,body").animate({scrollTop: dataScrolled}, 10);
            $("html,body").removeAttr('data-scrolled');
            $(".product__image-wrapper__thumbs").removeAttr("style");
        }),
        $("#menu-toggle").click(function (t) {
            t.stopPropagation();
        }),
        $("#side-menu").click(function (t) {
            t.stopPropagation();
        }),
        $(".cart-edit-modal").click(function (t) {
            $(t.target).closest(".modal-body,.edit-quant").length || ($(".cart-edit-modal").fadeOut(), $("html").removeClass("modal-open"));
        }),
        $(".s-mobile-collection-menu").click(function () {
            $("#hasChild-filter .refinetext").toggleClass("open"), $(this).children(".s-mobile-collection-menu__list").slideToggle();
        }),
        $(window).resize(function () {
            t();
        }),
        t(),
        updateCart();
    

        // Dynamic checkout buttons styling
        $(window).load(function(){
            setTimeout(function(){
                var $filters = new ProductFilters(),paypal = $('iframe[title="Checkout with PayPal"]');
                $('[data-shopify-buttoncontainer]').attr('style','display:block !important;');
                paypal.attr('style','opacity:1 !important;').after(`<icons class="payment-icons">
                                <img src="${$filters.asset_url('visa.svg')}"/>
                                <img src="${$filters.asset_url('master-card.svg')}"/>
                                <img src="${$filters.asset_url('amex.svg')}"/>
                                <img src="${$filters.asset_url('discover.svg')}"/>
                            </icons>`)
                .parents('li').attr('style','height: 95px !important;');
                $('.additional_checkout_buttons').fadeIn(500);
            },500);
            
        });
        // End 
        
        homeSliderInit(),
        saleSliderInit(),
        changeFreeGiftThumb();
        // ProductRecommendations();
        relatedSliderInit();

        if(window.template === 'product'){
            $('#shopify-section-product-recommendations').loadOnScroll({
                script: 'ProductRecommendations',
                delay: 200,
                threshold: 500
            });
        }else{
            ProductRecommendations();
        }

        $('#NewsletterForm').loadOnScroll({
            section_id: 'footer-newsletter',
            api: true,
            threshold: 800
        });
    });
    

    function ProductFilters() {
        console.log("Filter started");
    }
    (ProductFilters.prototype = {
        config: {
            acceptedOptions: ["color", "colour"],
            collection: Shopify.collection,
            expiry_time: 36e5,
            colorTree: $("#color-tree"),
            sizeTree: $("#size-tree"),
            deviceTree: $("#device-tree"),
            priceTree: $("#price-range"),
            skeleton: $(".skeleton"),
            checkbox: ".variant-input input",
            productContainer: $(".c-collection-template__products"),
            filterOptions: ["color", "size", "device"],
            mainWrap: $(".main-filter"),
            selectedFilters: $(".selected-filters"),
            product_count: $(".product-count"),
            sizeFilterButtons: $("#size-filter-buttons"),
            sizeSkeletonLoader: $('.horizontal-filter-skeleton'),
            featured_products: {},
            labels: {
                colors: "Colour",
                sizes: "Size",
                devices: "Device Fit",
                price_range: "Price"
            },
            data: {},
            min_max: {},
            sortBy: $("#sort-by-mobile"),
            loader: $(".filter-loader"),
            colorOrder: ["Tan", "Black", "Blush", "Azzurra", "Burgundy", "Olive"],
            colorChart: {
                Tan: "#B25E32",
                Black: "#000",
                Blush: "#F3CFB9",
                Blue: "#285065",
                Azzurra: "#285065",
                Burgundy: "#66313B",
                Olive: "#766651"
            },
            sizeOrder: ["Extra Small", "Small", "Medium", "Large", "Extra Large"],
            deviceOrder: ['5.8" Smartphone', '6.5" Smartphone', '7.9" Mini Tablet', '11" Tablet', '13" Laptop', '15" Laptop', "DSLR Camera"],
            sort: {
                "created-descending": {
                    name: "A - z",
                    method: function (t, e) {
                        return e.created_at - t.created_at
                    }
                },
                "price-ascending": {
                    name: "Price, Low to High",
                    method: function (t, e) {
                        return t.price - e.price
                    }
                },
                "price-descending": {
                    name: "Price, High to Low",
                    method: function (t, e) {
                        return e.price - t.price
                    }
                }
            },
            subCategory: $("#sub-category"),
            page: 2,
            product: 12,
            pagination: ".AjaxinatePagination",
            method: "scroll",
            container: ".AjaxinateLoop",
            offset: 0,
            loadingText: '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>',
            callback: null,
            lastCallback: null,
            paginationElement: $("#Wanderers-Pagination"),
            containerElement: $("#Wanderers-Loop"),
            inpMin: '#min_price', //pfbf
            inpMax: '#max_price', //bfbf
            sizeFilterButton: '.size-button input[type="checkbox"]',
            clearSizeBtn: '.size-button label[data-filter="sizes"]',
        },
        setWithExpiry: function (t, e) {
            var a = {value: e};
            try {
                sessionStorage.setItem(t, JSON.stringify(a))
            } catch (e) {
                window.sessionStorage.clear(), sessionStorage.setItem(t, JSON.stringify(a))
            }
        },
        getWithExpiry: function (t) {
            var e = sessionStorage.getItem(t);
            if (!e) return null;
            var o = JSON.parse(e);
            return o.value
        },
        isset: function (t, e) {
            return "boolean" != typeof e && -1 !== e.indexOf(t)
        },
        getCollectionUrl: function () {
            return window.location.href.split("?")[0]
        },
        asset_url: function (t) {
            return theme.soldout_url.split("soldout.png")[0] + t
        },
        handlize: function (t) {
            return t.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")
        },
        getFilterOptions: function (t) {
            var e = this,
                o = [],
                a = [],
                n = [],
                i = [],
                r = [],
                c = this.config.collection,
                s = this.getParams();
            $(this.config.data.products).each(function (t, o) {
                var n = e.variantSizes(o.tags);
                n && !e.isset(n, a) && a.push(n), i.push(o.price_min), r.push(o.price_max)
            }), $(t).each(function (t, a) {
                var i = e.variantColors(a);
                i && $(i).each(function (t, a) {
                    e.isset(a, o) || o.push(a)
                });
                var r = e.devices(a.tags);
                r && $.merge(n, r)
            }), "colors" in s && Object.keys(s).length >= 2 && $(this.config.data.products).each(function (t, o) {
                var n = e.variantColors(o),
                    i = s.colors[0];
                e.isset(i, n) && function (t) {
                    var o = e.variantSizes(t.tags);
                    o && !e.isset(o, a) && a.push(o)
                }(o)
            });

            var l = [];
            return $(n).each(function (t, o) {
                e.isset(o, l) || l.push(o)
            }), {
                colors: o,
                sizes: a,
                devices: l,
                ranges: {
                    min_price: i.length ? Math.min(...i) / 100 : c.min_price,
                    max_price: r.length ? Math.max(...r) / 100 : c.max_price
                }
            }
        },
        variantColors: function (t) {
            var e = t.options_without_values,
                o = this.colorIndex(e);
            return o > -1 && t.options[o].values
        },
        variantSizes: function (t) {
            for (var e = this.config.collection.handle, o = 0; o < t.length; o++)
                if (this.isset(":" + e, t[o])) return t[o].split(":")[0];
            return !1
        },
        devices: function (t) {
            for (var e = [], o = 0; o < t.length; o++)
                if (this.isset("device:", t[o])) {
                    var a = t[o].split(":");
                    e.push(a[1])
                }
            return !!e.length && e
        },
        toTitleCase: function (t) {
            return t.replace(/(?:^|\s)\w/g, function (t) {
                return t.toUpperCase()
            })
        },
        sortColors: function (t) {
            var e = this.config.colorOrder,
                o = [],
                a = [];
            return e.forEach(function (e) {
                t.indexOf(e) > -1 && o.push(e)
            }), t.forEach(function (t) {
                -1 === e.indexOf(t) && a.push(t)
            }), o.concat(a)
        },
        buildColorFilter: function (t) {
            var e = this,
                o = this.sortColors(t),
                a = '\n    <h5>Colour <a href="javascript:" class="clear-filter" data-filter="colors">Clear</a></h5>\n    <ul class="color-filter options-list">';
            return $(o).each(function (t, o) {
                var n = o in e.config.colorChart ? "background-color:" + e.config.colorChart[o] : "background-image:url(" + e.asset_url(e.handlize(o) + ".png") + ")";
                a += `<li><div class="variant-input color">\n        <input class="visually-hidden" data-value="${o.toLowerCase()}" type="checkbox" value="${o}" name="colors" id="option-color-${e.handlize(o)}">\n\t\t<label style="${n}"\n\t\tfor="option-color-${e.handlize(o)}">\n      <img class="crossed-out" src="${theme.soldout_url}">\n      </label>\n      </div></li>`
            }), a += "</ul>"
        },
        sortSize: function (t) {
            var e = this.config.sizeOrder;
            return t.sort(function (t, o) {
                return e.indexOf(t) - e.indexOf(o)
            }), t
        },
        buildSizeFilter: function (t) {
            var self = this,
                e = this.sortSize(t),
                o = '\n    <h5>Size <a href="javascript:" class="clear-filter" data-filter="sizes">Clear</a></h5>\n    <ul class="size-filter options-list">';
            return $(e).each(function (t, e) {
                o += `<li>\n      <div class="variant-input size">\n      <input type="checkbox" value="${e}" data-value="${e.toLowerCase()}" name="sizes" id="option-size-${self.handlize(e)}">\n      <label for="option-size-${self.handlize(e)}">${e}</label>\n      </div></li>`
            }), o += "</ul>"
        },
        buildSizeFilterButtons: function (t) {      
            var self = this,
                e = this.sortSize(t),
                p = this.getUrlVars(),
                o = '<ul class="horizontal-bar">';
            o += `<li> <div class="size-button">\n<label data-filter="sizes" class="${!('sizes' in p) ? 'selected' : ''}">All</label></div></li>`;

            return $(e).each(function (t, e) {
                o += `<li>\n      <div class="size-button">\n      <input type="checkbox" value="${e}" data-value="${e.toLowerCase()}" name="sizes" id="size-btn-${self.handlize(e)}">\n      <label for="size-btn-${self.handlize(e)}">${e}</label>\n      </div></li>`
            }), o += "</ul>"
        },
        sortDeviceFit: function (t) {
            var e = this.config.deviceOrder;
            return t.sort(function (t, o) {
                return e.indexOf(t) - e.indexOf(o)
            }), t
        },
        buildDeviceFilter: function (t) {
            var e = this,
                o = e.sortDeviceFit(t),
                a = '\n    <h5>Device Fit <a href="javascript:" class="clear-filter" data-filter="devices">Clear</a></h5>\n    <ul class="device-filter options-list">';
            return $(o).each(function (t, o) {
                a += `<li>\n      <div class="variant-input device">\n      <input type="checkbox" data-value="${o.replace('"', "|").toLowerCase()}" value="${o.replace('"', "|")}" name="devices" id="option-device-${e.handlize(o)}">\n      <label for="option-device-${e.handlize(o)}">${o}</label>\n      </div></li>`
            }), a += "</ul>"
        },
        cc: function (t, e) {
            var o = "undefined" != typeof Cookies && Cookies.get(CURRENCY_COOKIE_NAME) ? Cookies.get(CURRENCY_COOKIE_NAME) : window.Currency.currentCurrency || window.Currency.currency,
                a = e || o;
            return window.Currency.convert(t, window.Currency.currency, a).toFixed(2)
        },
        //pfbf
        buildPriceFilter: function () {
            var e = this,
                n = e.config.min_max,
                a = e.rtt(n.min_price, 'down'),
                i = e.rtt(n.max_price, 'up');
            a = defaultFormat(e.cc(a))
            i = defaultFormat(e.cc(i));
            e.config.priceTree.html(
                `<h5>Price <a href="javascript:" class="clear-filter" style="display:none" data-filter="prices">Clear</a></h5>
            <div class="price-boxes">
                <span>${e.symbol()}</span>
                <input value="${a}" data-temp="${a}" type="number" id="min_price" class="price-range-field" />
                <span> - </span>
                <input value="${i}" data-temp="${i}" type="number" id="max_price" class="price-range-field" />
            </div>
            <div id="price-slider" class="price-filter-range" name="rangeInput"></div>`
            ), e.config.mainWrap.fadeIn(500);

            var t = document.getElementById("price-slider"),
                r = [document.getElementById("min_price"), document.getElementById("max_price")],
                mnp = $(r[0]), mxp = $(r[1]),
                price_change = function (_this, type) {
                    var ival = parseFloat($(_this).val()),
                        mn = parseFloat(e.cc(e.rtt(n.min_price, 'down'))),
                        mx = parseFloat(e.cc(e.rtt(n.max_price, 'up'))),
                        current_mn = parseFloat(mnp.val()),
                        current_mx = parseFloat(mxp.val()),
                        new_val = type == 0 ? Math.min(current_mn, current_mx) : Math.max(current_mn, current_mx);
                    ival = (current_mx < current_mn ? new_val : ival);
                    ival = (ival < mn || ival > mx ? e.cc(e.rtt(n[type == 0 ? 'min_price' : 'max_price'], type==0 ? 'down' : 'up')) : ival);

                    var _pr = defaultFormat(ival);
                    $(_this).attr({ 'data-temp': _pr });
                    t.noUiSlider.set(type == 0 ? [_pr, null] : [null, _pr]), e.filterProducts();
                };

            noUiSlider.create(t, { start: [a, i], connect: !0, step: 1, range: { min: a, max: i } });

            t.noUiSlider.on("update", function (n, t) {

                var this_inp = t == 0 ? mnp : mxp;
                var real_inp = this_inp.attr('data-temp'), clr_btn = $('a[data-filter="prices"]');

                switch (true) {
                    case t == 0 && real_inp < a:
                        real_inp = a;
                        break;
                    case t == 0 && real_inp > i:
                        real_inp = a;
                        break;
                    case t == 1 && real_inp > i:
                        real_inp = i;
                        break;
                    case t == 1 && real_inp < a:
                        real_inp = i;
                        break;
                }

                real_inp = e.cc(real_inp ? real_inp : n[t]);

                this_inp.val(real_inp);
                n[0] != Math.round(a) || n[1] != Math.round(i) ? clr_btn.show() : clr_btn.hide();

            });

            t.noUiSlider.on('slide', function (n, m) {
                $([mnp, mxp]).each(function (i, inp) {
                    inp.val(e.cc(n[i])).attr('data-temp', defaultFormat(e.cc(n[i])));
                });
            });

            t.noUiSlider.on("change", function (n, i) {
                e.filterProducts($(this.target));
            });

            $([mnp, mxp]).each(function (i, inp) {
                inp.unbind("change"), inp.on("change", function () {
                    price_change(this, i);
                    e.setSelectedFilters();
                });
            });
            e.bindEvents();
        },
        //end pfbf

        fetchProducts: function (t, s) {
            var o = this.config.collection,
                a = "?sort_by=" + (s ? s : this.config.sortBy.val());
            $.ajax({
                url: `/collections/${o.handle}${a}`,
                data: "view=search",
                type: "GET",
                cache: !0,
                success: t
            })
        },
        buildProductGrid: function (t) {
            return decodeURIComponent(t.print)
        },
        has_colors: function (t, e) {
            t = t[0];
            var o = this.variantColors(e);
            return !(!o || !this.isset(t, o))
        },
        has_sizes: function (t, e) {
            for (var o = this.config.collection.handle, a = e.tags, n = 0; n < t.length; n++) {
                var i = t[n] + ":" + o;
                if (this.isset(i, a)) return !0
            }
            return !1
        },
        has_devices: function (t, e) {
            for (var o = e.tags, a = 0; a < t.length; a++) {
                var n = "device:" + t[a].replace("|", '"');
                if (this.isset(n, o)) return !0
            }
            return !1
        },
        has_price_range: function (t, e) {
            var o = 100 * t.min_price,
                a = 100 * t.max_price;
            return e.price_min >= o && e.price_min <= a || e.price_max >= o && e.price_max <= a
        },
        isMatched: function (t, e) {
            for (var o in e) {
                var a = e[o];
                if (!this["has_" + o](a, t)) return !1
            }
            return !0
        },
        filterByOptions: function (t, e) {
            var o = this.isMatched(t, e);
            var widthwidth = $(window).width();
            if (o) {
                var a = this.buildProductGrid(t),
                    n = e.colors;
                if ("colors" in e) {
                    var i = this.getColorImage(t, n),
                        r = document.createElement("div"),
                        elem_len = 0;
                    r.innerHTML = a;
                    var c = $(r).find("a"),
                        s = c.attr("href");
                    c.attr("href", s + "?variant=" + i.id), "featured_image" in i && ($(r).find("a img").attr({
                        "src": i.featured_image.replace("_300x", "_100x"),
                        "data-src": i.featured_image
                    })),elem_len=$(r).find(".swatch-element").length;
                        $(r).find(".swatch-element").each(function (t, e) {
                        var o = $(e).data("value") == n ? 1 : t + 2;
                        $(e).removeAttr('style').removeClass('mobile-hide-strict').attr('data-order',o).css({
                            order: o,
                            "-webkit-order": o
                        });
                        
                    });
                    var result = $(r).find(".sorting_elems").sort(function (a, b) {

                        var contentA =parseInt( $(a).data('order'));
                        var contentB =parseInt( $(b).data('order'));
                        return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
                    });
                    $(r).find("div.swatch").addClass('filtered-swatches').append(result);
                    if(elem_len > 6){
                        $(r).find(".swatch-element:gt(5)").hide();
                        $(r).find(".swatch-element:gt(3)").addClass('mobile-hide-strict');
                    }

                    a = $(r).html();
                }

                this.config.productContainer.append(a);


            } else Object.keys(e).length || (a = this.buildProductGrid(t), this.config.productContainer.append(a));
            return o
        },
        filterProducts: function (t) {
            var e = this.getParams(),
                o = this,
                a = this.config.data.products,
                n = [];
            // 			this.config.loader.show();
            Object.keys(e).length, this.updateUrl(e), o.config.productContainer.empty(), $(a).each(function (t, a) {
                o.filterByOptions(a, e) && n.push(a)
            });
            var i = this.config.collection;
            this.config.product_count.html(n.length + " " + i.title)
            this.rebuildFilter(n, t)
            $(".mobile-loader").fadeOut()
            this.config.containerElement.css('opacity', '1');
            o.config.loader.fadeOut()
            o.config.paginationElement.empty()
            checkCurrencyCookie()
        },
        filterProductsOnBack: function (t) {
            var o = this,
                e = o.getParams(),
                a = o.config.data.products,
                i = o.config.collection,
                n = [];
            Object.keys(e).length, o.config.productContainer.empty(), $(a).each(function (t, a) {
                o.filterByOptions(a, e) && n.push(a)
            });
            o.config.product_count.html(n.length + " " + i.title)
            o.rebuildFilter(n, t)
            $(".mobile-loader").fadeOut()
            o.config.containerElement.css('opacity', '1');
            o.config.loader.fadeOut()
            o.config.paginationElement.empty()
            checkCurrencyCookie()
        },
        colorIndex: function (t) {
            return -1 === t.indexOf("Color") ? t.indexOf("Colour") : t.indexOf("Color")
        },
        getColorImage: function (t, e) {
            return t.variants[e]
        },
        getAllUrlParams: function (t) {
            var e = t ? t.split("?")[1] : window.location.search.slice(1),
                o = {};
            if (e)
                for (var a = (e = e.split("#")[0]).split("&"), n = 0; n < a.length; n++) {
                    var i = a[n].split("="),
                        r = i[0],
                        c = void 0 === i[1] || i[1];
                    if (r = r.toLowerCase(), "string" == typeof c && (c = c.toLowerCase()), r.match(/\[(\d+)?\]$/)) {
                        var s = r.replace(/\[(\d+)?\]/, "");
                        if (o[s] || (o[s] = []), r.match(/\[\d+\]$/)) {
                            var l = /\[(\d+)\]/.exec(r)[1];
                            o[s][l] = c
                        } else o[s].push(c)
                    } else o[r] ? o[r] && "string" == typeof o[r] ? (o[r] = [o[r]], o[r].push(c)) : o[r].push(c) : o[r] = c
                }
            return o
        },
        //pfbf
        getParams: function () {
            var s = this,
                t = $(s.config.checkbox),
                e = {};
            return t.each(function (t, o) {
                if ($(o).is(":checked")) {
                    var a = $(o).attr("name");
                    a in e || (e[a] = []), e[a].push($(o).val())
                }
            }), e.price_range = {
                min_price: $(s.config.inpMin).attr("data-temp"),
                max_price: $(s.config.inpMax).attr("data-temp")
            }, e
        },
        clearUrl: function () {
            return;
            var t = this.config.sortBy.val(),
                e = this.config.collection;
            var o = {
                session_key: e.handle + "-" + e.id,
                collection_id: e.id
            };
            var a = {
                prices: [
                    this.rtt($(this.config.inpMin).attr('data-temp'), 'down'),
                    this.rtt($(this.config.inpMax).attr('data-temp'), 'up')
                ],
                sort_by: t
            },
                n = $.param(a, !0),
                i = decodeURIComponent(n);
            history.pushState(o, "", "?" + i)
        },
        updateUrl: function (t) {
            var o = {}, s = this.config.sortBy.val();
            o.sort_by = s;
            for (var a in t) "price_range" != a && (o[a] = t[a]);
            o.prices = [],
                o.prices.push($(this.config.inpMin).attr('data-temp')),
                o.prices.push($(this.config.inpMax).attr('data-temp'));
            var n = $.param(o, !0),
                i = decodeURIComponent(n),
                r = this.config.collection;
            var c = {
                session_key: r.handle + "-" + r.id,
                collection_id: r.id
            };
            history.pushState(c, "", "?" + i)
        },


        bindEvents: function () {
            var t = this;

            $(this.config.checkbox).unbind("change"), $(this.config.checkbox).on("change", function () {
                const option_name = $(this).attr("name")
                const params = t.getParams()

                $(".variant-input").removeClass("selected")

                if("colors" === option_name){
                    $('input[name="colors"]').not(this).prop("checked", !1)
                }

                if ("sizes" === option_name) {
                    $(t.config.clearSizeBtn).toggleClass('selected',!('sizes' in params))
                    $(`#size-btn-${t.handlize(this.value)}`).prop('checked', this.checked);
                }

                if($(this).is(":checked")){
                    $(this).parents(".variant-input").addClass("selected")
                }

                t.filterProducts($(this));
            });

            $(".clear-filter").unbind("click"), $(".clear-filter").on("click", function (e) {
                e.preventDefault();
                var o = $(this).data("filter");

                $('input[name="' + o + '"]').prop("checked", !1)
                if("colors" === o){ 
                    $(".variant-input.color").removeClass("selected")
                }else if("sizes" === o){
                    $(t.config.clearSizeBtn).addClass('selected')
                }else if("prices" === o){
                    t.buildPriceFilter()
                }
                t.filterProducts($('input[name="' + o + '"]'));
            });

            $(".hide-filter,#filter-overlay").unbind("click"), $(".hide-filter,#filter-overlay").on("click", function () {
                $("html").removeClass("is--filter-open"), $("#filter-overlay").fadeOut(), $(".filter-wrapper,.apply-btn").css("left", "-100%");
            });

            $(".refine-by").unbind("click"), $(".refine-by").on("click", function () {
                $("html").addClass("is--filter-open"), $(".filter-wrapper,.apply-btn").css("left", 0),
                    $("#filter-overlay").fadeIn();
            });

            $(document).off('change',t.config.sizeFilterButton)
            $(document).on('change',t.config.sizeFilterButton,(e)=>{
                const size_checkbox = e.currentTarget;
                const selected_filters = $(`${t.config.sizeFilterButton}:checked`).length
                $(t.config.clearSizeBtn).toggleClass('selected',!selected_filters)
                $(`#option-size-${t.handlize(size_checkbox.value)}`).prop('checked', size_checkbox.checked);
                t.filterProducts($(size_checkbox))
            })

            $(document).off("click", t.config.clearSizeBtn)
            $(document).on("click", t.config.clearSizeBtn ,function (e) {
                e.preventDefault();
                $('.mobile-loader').show();
                // t.config.containerElement.css({'opacity': '0.1'});
                $(t.config.clearSizeBtn).addClass('selected')
                $('input[name="sizes"]').prop("checked", !1)
                t.filterProducts($('input[name="sizes"]'));
            });
            

            this.config.sortBy.unbind("change"), this.config.sortBy.on("change", function (e) {
                e.preventDefault(), t.config.loader.fadeIn();
                var o = t.config.collection, a = o.handle + "-" + o.id, n = $(this).val();
                var i = {
                    session_key: a,
                    collection_id: o.id
                }, r = "?sort_by=" + n;
                if (history.pushState(i, "", r), n in t.config.sort) {
                    var c = t.getWithExpiry(a, e);
                    if(!c){
                        for (var key in sessionStorage) {
                        if (key.indexOf(a) !== -1){
                            c = t.getWithExpiry(key, e);
                            break
                        }
                        }
                    }
                    t.config.data = JSON.parse(c), t.config.data.products = t.config.data.products.sort(t.config.sort[n].method),
                        t.filterProducts();
                } else (
                    c = t.getWithExpiry(a + "-"+n)) ? (t.config.data = JSON.parse(c),
                    t.filterProducts()) : t.fetchProducts(function (e) {
                        t.setWithExpiry(a + "-"+n, e), t.config.data = JSON.parse(e),
                            t.filterProducts();
                    });
            });

            $(".o-currency-selector__select").unbind("change"),
                $(".o-currency-selector__select").on("change", function () {
                    var e = $(this).val(),
                        o = $(t.config.inpMin),
                        a = $(t.config.inpMax),
                        n = o.attr("data-temp"),
                        i = a.attr("data-temp"),
                        s = t.symbol(e);
                    o.val(t.cc(n, e)), a.val(t.cc(i, e)),
                        $(".price-boxes span:first").html(s);

                    var chosenRange = $('[data-class="selected-price"]');
                    if (chosenRange.length) {
                        chosenRange.html(`${t.config.labels.price_range}: <strong><span>${s + t.cc(n, e)}</span> - <span>${s + t.cc(i, e)}</span></strong>\n        <a href="javascript:" class="clear-filter-top" data-filter="price_range"><span class="wt-clear"></span></a>`)
                        t.bindTopEvents();
                    }
                });
        },
        //end pfbf

        clearStorage: function () {
            var t = this.config.collection,
                e = t.handle + "-" + t.id;
            sessionStorage.removeItem(e),
                sessionStorage.removeItem(e + "-manual"),
                sessionStorage.removeItem(e + "-best-selling");
        },
        bindOnce: function () {
            this.config.subCategory.unbind("click"), this.config.subCategory.on("click", function () {
                $(this).toggleClass('dropdown--open'); $(".select-wrap").toggle()
            })
        },
        getFeatured: function () {
            var t = this.config.collection,
                e = this,
                o = t.handle + "-" + t.id;
            this.fetchProducts(function (t) {
                e.setWithExpiry(o + "-manual", t)
            }, 'manual')
            this.fetchProducts(function (t) {
                e.setWithExpiry(o + "-best-selling", t)
            },'best-selling')
        },
        resetFilters: function () {
            $('.variant-input input[type="checkbox"]').prop({
                checked: !1,
                disabled: !1
            }), $('.clear-filter:not(.exception)').hide(), $(".variant-input.color").removeClass("selected"), this.buildPriceFilter(), this.filterProducts(), this.clearUrl(), this.config.selectedFilters.empty()
        },
        resetOnly: function () {
            $('.variant-input input[type="checkbox"]').prop({
                checked: !1,
                disabled: !1
            }), $('.clear-filter:not(.exception)').hide(), $(".variant-input.color").removeClass("selected"), this.buildPriceFilter(), this.clearUrl(), this.config.selectedFilters.empty()
        },
        //pfbf
        rtt: function (t, e) {
            return 'up' == e ? (10*Math.ceil(t/10)) : 'down' == e ? 10*Math.floor(t/10) : t
        },
        //end pfbf
        symbol: function (t) {
            var e = "undefined" != typeof Cookies && Cookies.get(CURRENCY_COOKIE_NAME) ? Cookies.get(CURRENCY_COOKIE_NAME) : window.Currency.currentCurrency || window.Currency.currency,
                o = t || e;
            return Currency.moneyFormats[o].money_format.replace("{{amount}}", "").replace("{{amount_no_decimals}}", "")
        },
        min_max: function () {
            var i = [],
                r = [],
                t = this;
            $(this.config.data.products).each(function (ind, o) {
                if (!t.isset(o.price_min, i)) i.push(o.price_min);
                if (!t.isset(o.price_max, r)) r.push(o.price_max);
            });
            return {
                min_price: Math.min(...i) / 100,
                max_price: Math.max(...r) / 100
            };
        },
        bindTopEvents: function () {
            var t = this;

            $(".clear-filter-top").unbind("click");
            $(".clear-filter-top").on("click", function () {
                var e = $(this).data("filter");
                var o = $('input[value="' + e + '"]');

                if ("price_range" == e) {
                    $(this).remove();
                    t.buildPriceFilter();
                }
                if ("range_price" != e) {
                    o.prop("checked", !1);
                }
                if ("colors" == o.attr("name")) {
                    o.parents(".variant-input").removeClass("selected");
                }

                const selected_filters = $(`${t.config.sizeFilterButton}:checked`).length
                if ("sizes" == o.attr("name") && !selected_filters) {
                    $(t.config.clearSizeBtn).addClass('selected')
                }
                t.filterProducts(o);
            });
            
            $(".clear-all").unbind("click")
            $(".clear-all").on("click", function (e) {
                e.preventDefault()
                $(".refine-by").removeClass("active").find("span").empty()
                $(t.config.clearSizeBtn).addClass('selected')
                $('input[name="sizes"]').prop("checked", !1)
                t.resetFilters()
            })
        },
        rebuildFilter: function (t, e) {
            if (e) {
                var o = this.getFilterOptions(t),
                    a = this.getParams();
                for (var n in "rangeInput" != e.attr("name") ? $(".variant-input input").not('[name="' + e.attr("name") + '"]').prop({
                    disabled: !0
                }) : $(".variant-input input").prop({
                    disabled: !0
                }), o)
                    if ("price_range" != n) {
                        var i = $('a[data-filter="' + n + '"]');
                        n in a ? i.show() : i.hide();
                        var r = o[n];
                        $(r).each(function (t, e) {
                            "devices" == n && (e = e.replace('"', "|"));
                            var o = $('.variant-input input[value="' + e + '"]');
                            o.is(":checked") || o.prop("checked", !1), o.prop("disabled", !1)
                        })
                    }
                this.setSelectedFilters(a)
            }
        },
        //pfbf
        setSelectedFilters: function (obj) {
            var t = this;
            var string = (obj = obj || this.getParams(), Object.keys(obj).length);
            var type = this.config.collection,
                mm = this.config.min_max,
                value = "<ul>";

            for (var i in obj) {
                var item = obj[i];
                if ("price_range" != i) {
                    $(item).each(function (j, originalBaseURL) {
                        $('[data-filter="' + i + '"]').show();
                        value = value + `<li>${t.config.labels[i]}: <strong>${originalBaseURL.replace("|", '"')}</strong>\n          <a href="javascript:" class="clear-filter-top" data-filter="${originalBaseURL}"><span class="wt-clear"></span></a>\n          </li>`;
                    });
                } else {
                    if (!(t.rtt(mm.min_price, 'down') == Math.round(item.min_price) && t.rtt(mm.max_price, 'up') == Math.round(item.max_price))) {
                        var s = t.symbol();
                        value = value + `<li data-class="selected-price">${t.config.labels[i]}: <strong><span>${s + t.cc(item.min_price)}</span> - <span>${s + t.cc(item.max_price)}</span></strong>\n        <a href="javascript:" class="clear-filter-top" data-filter="${i}"><span class="wt-clear"></span></a>\n        </li>`;
                    }
                }
                if (2 == string && "price_range" in obj && "price_range" != i) {
                    $('input[name="' + i + '"]').prop("disabled", false);
                }
            }

            value = value + "</ul>";
            this.config.selectedFilters.empty();
            if (string) {
                this.config.selectedFilters.html(`<h5>FILTERS <a href="javascript:" class="clear-all">Clear All</a></h5>${value}`);
                this.bindTopEvents();
            }
            var readersLength = this.config.selectedFilters.find("li").length;
            if (readersLength) {
                $(".refine-by").addClass("active").find("span").text(`(${readersLength})`);
            } else {
                this.config.selectedFilters.empty();
                $(".refine-by").removeClass("active").find("span").empty();
            }
        },

        alreadyReset: function () {
            var e = this.getParams(),
                l = Object.keys(e).length,
                r = this.config.min_max,
                p = e.price_range,
                min_price = this.rtt(r.min_price, 'down'),
                max_price = this.rtt(r.max_price, 'up');

            if (p.min_price == min_price &&
                p.max_price == max_price &&
                l == 1 &&
                ('price_range' in e)) {
                return true;
            } else {
                return false;
            }
        },
        //end pfbf
        processData: function () {
            if (this.config.data.products.length) {
                this.config.collection;
                var t = this.config.data.products,
                    e = this.getFilterOptions(t);
                if ("colors" in e && e.colors.length) {
                    var o = this.buildColorFilter(e.colors);
                    this.config.colorTree.html(o)
                }
                if ("sizes" in e && e.sizes.length) {
                    var a = this.buildSizeFilter(e.sizes);
                    this.config.sizeTree.html(a)

                    var b = this.buildSizeFilterButtons(e.sizes);
                    this.config.sizeFilterButtons.html(b)
                }
                if ("devices" in e && e.devices.length) {
                    var n = this.buildDeviceFilter(e.devices);
                    this.config.deviceTree.html(n)
                }
                this.buildPriceFilter(), this.bindEvents(), this.setFilters()
            }
            this.config.sizeSkeletonLoader.fadeOut()
            this.config.skeleton.fadeOut()
        },
        getUrlVars: function () {
            var t = {};
            return window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (e, o, a) {
                t[o] = a
            }), t
        },
        getUrlParam: function (t, e) {
            var o = e;
            return window.location.href.indexOf(t) > -1 && (o = this.getUrlVars()[t]), o
        },
        arrayDiff: function (array1, array2) {
            var newItems = [];
            jQuery.grep(array2, function (i) {
                if (jQuery.inArray(i, array1) == -1) {
                    newItems.push(i);
                }
            });
            return newItems;
        },
        setFilters: function () {
            var t = this.getAllUrlParams(window.location.href);
            var filters = ['prices', 'colors', 'sizes', 'devices'];
            var obtained = Object.keys(t), min_max = this.config.min_max;
            var filtersToRemove = this.arrayDiff(obtained, filters);
            $(filtersToRemove).each(function (i, r) {
                $('input[name="' + r + '"]').prop("checked", !1);
                if (r == 'colors') {
                    $('.variant-input').removeClass('selected');
                }
            });
            for (var e in t)
                if ("prices" == e) {
                    var o = document.getElementById("price-slider"), a = t[e];
                    //pfbf
                    var min = this.rtt(min_max.min_price, 'down');
                    var max = this.rtt(min_max.max_price, 'up');
                    if (a[0] != min || a[1] != max) {
                        $('a[data-filter="prices"]').show();
                    }
                    $(this.config.inpMin).attr('data-temp', (a[0] == 0 ? min : a[0]));
                    $(this.config.inpMax).attr('data-temp', (a[1] == 0 ? max : a[1]));
                    //end pfbf
                    o.noUiSlider.set([parseInt(a[0]), parseInt(a[1])])
                } else if ("sort_by" == e) this.config.sortBy.val(t[e]);
                else if ($('input[name="' + e + '"]').prop("checked", !1), $.isArray(t[e])) $(t[e]).each(function (t, e) {
                    $('input[data-value="' + e.replace("+", " ") + '"]').prop("checked", !0)
                });
                else {
                    var n = $('input[data-value="' + t[e].replace("+", " ") + '"]');
                    n.prop("checked", !0), "colors" == e && n.parents(".variant-input").addClass("selected")
                }
            this.setSelectedFilters()
        },
        initFilter: function (t) {
            this.config.data = JSON.parse(t);
            var e = this.config.sortBy.val();
            if (this.config.sort[e]) {
                var o = this.config.sort[e];
                this.config.data.products = this.config.data.products.sort(o.method)
            }
            this.config.min_max = this.min_max();
            this.processData();
            if (this.alreadyReset()) {
                this.config.containerElement.css('opacity', '1');
                $('.mobile-loader').hide();
                // 				this.initScrolling();
                return false;
            } else {
                this.filterProducts()
            }
        },
        initScrolling: function () {
            (this.nextPageLinkElement = this.config.paginationElement.find("a")),
                this.nextPageLinkElement && ((this.nextPageLinkElement.html(this.config.loadingText)), (this.nextPageUrl = this.nextPageLinkElement.attr('href')), this.loadMore());

        },
        loadMore: function () {
            if (!this.nextPageUrl) {
                return;
            }
            var self = this,
                t = this.nextPageUrl.split("?")[0],
                e = window.location.search,
                sort_by = '';
            if (e) {
                var param = e.replace('?', '').split('&');
                $(param).each(function (i, p) {
                    if (p.split('=')[0] == 'sort_by') sort_by = p;
                });
            }
            var url = t + "?page=" + this.config.page + (sort_by ? '&' + sort_by : "") + '&view=json';
            this.config.page++;
            $.ajax({
                url: url,
                type: 'GET',
                cache: true,
                headers: {
                    'Cache-Control': 'max-age=3600'
                },
                success: function (r) {
                    self.manageResponse(r);
                }
            });
        },

        manageResponse: function (r) {
            var self = this;
            r = JSON.parse(r);
            r.products.forEach(function (e, i) {
                var n = decodeURIComponent(e.print);
                self.config.containerElement.append(n);
            });

            self.config.product = self.config.product + r.products.length;
            if (self.config.product < r.total_products) {
                self.loadMore()
            } else {
                self.setPagePosition();
                self.config.paginationElement.empty();
            }
            checkCurrencyCookie();
        },

        setPagePosition: function () {
            var page_y = localStorage.getItem('page_y');
            if (page_y) {
                $('html, body').scrollTop(page_y);
            }
        },

        init: function () {
            if (!Shopify.collection) return;//BFCM
            var t = Shopify.collection,
                e = this,
                o = this.isset(t.handle, t.excluding);
            if (this.bindOnce(), o) this.initScrolling();
            else {
                var a = this.getUrlParam("sort_by", "manual");
                this.config.sortBy.val(a);
                var n = t.handle + "-" + t.id,
                    n1 = n+(['manual', 'best-selling'].indexOf(a) > -1 ? '-' + a : ''),
                    i = this.getWithExpiry(n1);
                i ?
                    (e.initFilter(i),e.setWithExpiry(n, i)) :
                    this.fetchProducts(function (t) {
                        e.setWithExpiry(n, t),
                        e.initFilter(t)
                    }), this.getFeatured();

                $(window).on('popstate', function (event) {
                    e.setFilters()
                    e.filterProductsOnBack();
                });
            }
        }
    });
    if($("body").hasClass("template-collection")){
        var $filters = new ProductFilters();
        $filters.init();
    }
$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
        $('.template-cart').find('input[name="checkout"]').removeAttr('disabled');
    }
});

$(document).on('click','.side-cart__btn,.btn--free-gift',function(){
    $(this).addClass('pseudo-loading');
});

$(window).on('load',function () {
    $('body').find('.pseudo-loading').removeClass('pseudo-loading');
});

$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
      $('body').find('.pseudo-loading').removeClass('pseudo-loading');
    }
});

//Start Stamped Reviews
var winWidth = $(window).width();
var isProductSeconds = (theme.template == 'product') ? window.isProductSeconds : '';
if(isProductSeconds == ""){
    if(winWidth >= 850){
        $(".testi_desktop").append('<div class="testimonials-wrapper stamped_rev_testi_inner hidden stamped_testimonial_grid tablet mobile"><div id="stamped_reviews_slider"></div></div>');
    }else if(winWidth >= 580 && winWidth < 850){
        $("#faqs-wrapper").after('<div class="grid__item one-whole"><div class="testimonials-wrapper stamped_rev_testi_inner hidden stamped_testimonial_grid tablet mobile"><div id="stamped_reviews_slider"></div></div></div>')
    }else if(winWidth < 580){
        $("#measurements").length ? 
        $("#measurements").after('<div class="testimonials-wrapper stamped_rev_testi_inner hidden stamped_testimonial_grid tablet mobile"><div id="stamped_reviews_slider"></div></div>') : $("#details").after('<div class="testimonials-wrapper stamped_rev_testi_inner hidden stamped_testimonial_grid tablet mobile"><div id="stamped_reviews_slider"></div></div>');
    }
}

var stampedApiUrl = "https://stamped.io/api/widget/reviews",
stampedCountUrl = "https://stamped.io/api/widget/badges",
stampedPubKey = "pubkey-G3ci2JTmKa6pJ0bRi5eQo9Q0io8Ysm",
homepageTake = 100,
productpageTake = 20,
homepageTag = "homepage",
home_slider_container = $('#stamped_reviews_slider'),
product_testi_container = $('.stamped_testimonial_grid'),
is_page_template = $('body').hasClass('template-page'),
shopDomain = theme.shop_domain,
myCountryIso = [],
allCountryIsoExceptUS = ["AU","GB","AL","AD","AT","BY","BE","BA","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","VA","HU","IS","IE","IM","IT","LV","LI","LT","LU","MK","MT","MD","MC","ME","NL","NO","PL","PT","RO","SM","RS","SK","SI","ES","SE","CH","TR","UA"],
euCountryIso = ["AL","AD","AT","BY","BE","BA","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","VA","HU","IS","IE","IM","IT","LV","LI","LT","LU","MK","MT","MD","MC","ME","NL","NO","PL","PT","RO","SM","RS","SK","SI","ES","SE","CH","TR","UA"],
is_product_page = 0;

function productIdDataCount(reviewProductJSON,productHANDLE,callback){
    var productDATA = {
        "productIds": [
            {
                "productId": reviewProductJSON.id,
                "productSKU": productHANDLE
            }
        ],
        "apiKey": stampedPubKey,
        "storeUrl": Shopify.shop
    }
    jQuery.ajax({
        url: stampedCountUrl,
        type: 'post',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify( productDATA ),
        processData: false,
        success: callback
    });
}

function getProductReviewGrid(e, shopTitle) {
var percentageRating = e.reviewRating / 5 * 100;
var revProductHandle = (Shopify.stamped_reviews_count < 4) ? Shopify.allAvailableProducts.handle[Shopify.allAvailableProducts.title.indexOf(e.productName.toLowerCase())] : '';
var reviewDateString = new Date(e.reviewDate).toDateString();
var reviewDateStringSplit = reviewDateString.split(" ");
var reviewDateNewString = reviewDateStringSplit[2] + " " + reviewDateStringSplit[1] + " " + reviewDateStringSplit[3];

var markup = `<div class="testimonials-slide">
<blockquote class="testimonials-slider__text">
<span class="testi_starratings"> 
  <div class="star-rating">
    <div class="back-stars"><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span>
      <div class="front-stars" style="width: ${percentageRating + '%'}"><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span></div>
    </div>
  </div>
</span>
<h3 class="testi_title">${e.reviewTitle}</h3>
<div class="testi_body_section ${Shopify.stamped_reviews_count < 4 ? 'with_image_onSide' : ''}">`;
markup += `<div class="testi_body_rev_section">
    <input type="checkbox" class="testi_expanded hide"><div class="rte-setting text-spacing ${Shopify.stamped_reviews_count < 4 ? 'with_image_onSide' : ''} testi_text"><span class="trucated_testi">${e.reviewMessage}</span><span class="more_review_toggle hide">more</span></div></a>
    ${Shopify.stamped_reviews_count < 4 ? '\
    <a class="testi_product_detail" href="'+revProductHandle+'">\
    <div class="testi_product_details">\
        <p class="testi_product_name">'+e.productName+'</p>\
    </div>\
    </a>' : ''
    }
    <div class="testi_customer_section">
    <div class="testi_customer_detail">
        <span class="testi_author">
        <span class="authorName">${e.author}</span>
        ${e.reviewVerifiedType == 2 ? '<span class="verified-dash">-</span><span class="verified_badge">Verified</span>' : ''}
        </span>
        ${e.location != '' ? '<span class="rev_location">'+e.location+',</span>' : ''}<small class="testi_date">${reviewDateNewString}</small>
    </div>
    </div>
    ${typeof e.reviewReply !== 'undefined' && e.reviewReply !== '' ? '\
    <div class="review_reply">\
      <p class="reply_toggle">1 Response <i class="fa fa-angle-down"></i></p>\
      <div class="reply_collapse hide">\
        <h3 class="shop_title">'+ shopTitle + '</h3>\
        <div class="reply_text">'+ e.reviewReply + '</div>\
      </div>\
    </div>' : ''
    }
  </div>`;
  if (Shopify.stamped_reviews_count < 4) {
    markup += `<div class="testi_body_img_section">
        <a class="testi_product_detail" href="${revProductHandle}">
            <div class="testi_product_img" style="background-image: url(${e.productImageThumbnailUrl})"></div>
        </a>
    </div>`;
}
markup += `</div>
</blockquote>
</div>`;
return markup;
}

function getProductTopbarGrid(e) {
var percentageRating = e.rating / 5 * 100;
return `<div id="stamped_reviews_topbar" class="stamped_reviews_topbar">
<div class="testi-rating">
<h1 class="testi-rating-digit">${Math.round(e.rating * 10) / 10}</h1>
<div class="testi_star_container">
<span class="testi_final_ratings">
  <div class="star-rating">
    <div class="back-stars"><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span>
      <div class="front-stars" style="width: ${percentageRating + '%'}"><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span></div>
    </div>
  </div>
</span>
<p class="testi_reviews_count">Based on <span class="testi-total-rev">${e.total}</span> reviews</p>
</div>
</div>
</div>`;
}

function getHomeReviewGrid(e) {
var percentageRating = e.reviewRating / 5 * 100;
var reviewDateString = new Date(e.reviewDate).toDateString();
var reviewDateStringSplit = reviewDateString.split(" ");
var reviewDateNewString = reviewDateStringSplit[2] + " " + reviewDateStringSplit[1] + " " + reviewDateStringSplit[3];
var revProductHandle = "products/"+Shopify.allAvailableProducts.handle[Shopify.allAvailableProducts.title.indexOf(e.productName.toLowerCase())];

return `<div class="testimonials-slide">
    <div class="testi_body_section with_image_onSide">
        <div class="testi_body_img_section">
            <a class="testi_product_detail" href="${revProductHandle}">
                <div class="testi_product_img" style="background-image: url(${e.productImageLargeUrl})">
                    <div class="testi_product_details">
                        <p class="testi_product_name">${e.productName}</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="testi_body_rev_section">
            <div class="testimonials-slider__text">
            <h3 class="testi_title">“${e.reviewTitle}”</h3>
            <span class="testi_starratings">
            <div class="star-rating">
            <div class="back-stars"><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span><span class='unicode-star empty'>&#9734;</span>
                <div class="front-stars" style="width: ${percentageRating + '%'}"><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span><span class='unicode-star'>&#9733;</span></div>
            </div>
            </div>
            </span>
            <input type="checkbox" class="testi_expanded hide">
            <div class="rte-setting text-spacing testi_text"><span class="trucated_testi">${e.reviewMessage}</span><span class="more_review_toggle hide">more</span></div>
            <span class="testi_author">
            <span class="authorName">${e.author}</span>
            ${e.reviewVerifiedType == 2 ? '<span class="verified-dash">-</span><span class="verified_badge">Verified</span>' : ''}
            </span>
            ${e.location != '' ? '<span class="rev_location">'+e.location+',</span>' : ''}<small class="testi_date">${reviewDateNewString}</small>
            </div>
    </div>
</div>`;
}

function stampedReview(data) {
    if (theme.template == '' && !is_page_template) { return }

    var reviewProductJson = (theme.template == 'product') ? CURRENT_PRODUCT : {};
    var productHandle = (theme.template == 'product') ? window.productHandle : '';
    var is_gift_card = (reviewProductJson.handle == 'gift-card') ? 1 : 0;
    var apiData = {
        storeUrl: Shopify.shop,
        apiKey: stampedPubKey
    };

    function stampedMainAjax(apiData){
        jQuery.ajax({
            url: stampedApiUrl,
            type: 'get',
            data: apiData,
            dataType: 'json',
            success: function (response) {

                if (is_product_page && Shopify.stamped_reviews_count < 4 && !(is_gift_card)) {
                    response.data = response.data.filter(item => Shopify.allAvailableProducts.title.indexOf(item.productName.toLowerCase()) > -1);
                }else if(theme.template == 'index' && shopDomain == 'wandererstravelco.co'){
                    response.data = response.data.filter(item => allCountryIsoExceptUS.indexOf(item.countryIso) == -1);
                }else if(theme.template == 'index' && shopDomain == "wandererstravelco.eu"){
                    response.data = response.data.filter(item => euCountryIso.indexOf(item.countryIso) > -1);
                }
                
                var shuffled_revs = (!is_page_template) ? response.data.sort(function () { return 0.5 - Math.random() }) : response.data;
                var selected_revs = shuffled_revs.slice(0, 20);
                if (is_product_page && selected_revs.length > 0) {
                    if(Shopify.stamped_reviews_count >= 4){
                        product_testi_container.prepend(getProductTopbarGrid(response));
                    }else{
                        product_testi_container.prepend(`<div class="stamped_reviews_topbar"><h3 class="testi-type-heading">Our customers say…</h3></div>`);
                    }
                }
                if (is_product_page && selected_revs.length <= 0) {
                    home_slider_container.hide();
                    $('.stamped_rev_testi_inner').css('visibility','hidden');
                }
                $.each(selected_revs, function (i, rev) {
                    if (theme.template == 'index' || is_gift_card) {
                        home_slider_container.append(getHomeReviewGrid(rev));
                    }
                    if (is_product_page) {
                        home_slider_container.append(getProductReviewGrid(rev, response.shop));
                    }
                });
            },
            complete: function (data) {
                $('.stamped_rev_testi_inner').removeClass('hidden');
                if (is_product_page == 1 || is_gift_card) {
                    home_slider_container.not('.slick-initialized').slick({
                        dots: !1, infinite: !1, arrows: !0, speed: 200, cssEase: 'ease-in-out', slidesToShow: 2, slidesToScroll: 2, autoplay: !1,
                        prevArrow: '<img class="control-c slick-prev" src="' + theme.left_arrow + '">',
                        nextArrow: '<img class="control-c slick-next" src="' + theme.right_arrow + '">',
                        responsive: [
                            { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                            { breakpoint: 1400, settings: { slidesToShow: 1, slidesToScroll: 1 } }
                        ],
                    });
                } else {
                    home_slider_container.not('.slick-initialized').slick({ dots: !0, infinite: !1, arrows: !0, fade: !1, speed: 200, cssEase: 'ease-in-out', slidesToShow: 3, slidesToScroll: 3, autoplay: !1,
                        prevArrow: '<img class="control-c slick-prev" src="' + theme.left_arrow + '">',
                        nextArrow: '<img class="control-c slick-next" src="' + theme.right_arrow + '">',
                        responsive: [
                            { breakpoint: 1025, settings: { dots: !1, slidesToShow: 1, slidesToScroll: 1 } },
                            { breakpoint: 1500, settings: { dots: !0, slidesToShow: 2, slidesToScroll: 2 } }
                        ],
                     });
                }
                setTimeout(function(){
                    $('.testi_text .trucated_testi').each(function(){
                        if(this.scrollHeight > this.offsetHeight){
                          $(this).parent().find('.more_review_toggle').addClass('isTrucated').removeClass('hide');
                        }
                    });
                },2000);
                home_slider_container.on('afterChange',function(){
                    $(this).find('input.testi_expanded').prop('checked', false);
                    $(this).find('.more_review_toggle.isTrucated').removeClass('hide');
                    $(this).find('.reply_collapse').addClass('hide');
                });
            }
        });
    }


    
    if (theme.template == 'index' || is_page_template || (theme.template == 'product' && is_gift_card)) {
        apiData = $.extend({}, apiData, {
            tags: homepageTag
        });
        if(shopDomain == 'wandererstravelco.com'){
            apiData = $.extend({}, apiData, {
                location: 'Australia',
            });
        }else if(shopDomain == 'wandererstravelco.uk'){
            apiData = $.extend({}, apiData, {
                location: 'United Kingdom'
            });
        }else{
            apiData = $.extend({}, apiData, {
                take: 100
            });
        }
        stampedMainAjax(apiData);
    } else if (theme.template == 'product') {
        is_product_page = 1;
        apiData = $.extend({}, apiData, {
            minRating: 1,
            take: productpageTake
        });
        
        if (Shopify.stamped_reviews_count >= 4) {
            apiData = $.extend({}, apiData, {
                productId: reviewProductJson.id,
                productSKU: productHandle
            });
            stampedMainAjax(apiData);
        }else{
            productIdDataCount(reviewProductJson,productHandle,function(response){
                if (response[0].count >= 4) {
                    Shopify.stamped_reviews_count = response[0].count;
                    apiData = $.extend({}, apiData, {
                        productId: reviewProductJson.id,
                        productSKU: productHandle
                    });
                } else {
                    apiData = $.extend({}, apiData, {
                        productType: reviewProductJson.type
                    });
                }
                stampedMainAjax(apiData);
            });

        } 
    }
}


if(isProductSeconds == ""){
    stampedReview();
}
$(document).on('click', '.collection-banner .text-toggle-btn', function () {
    $(this).parents('.top-content').find('.text-hidden').removeClass('text-hidden');
    $(this).css('opacity','0');
    $('html, body').animate({
        scrollTop: $(".collection-banner .text-visible").offset().top - 60
    }, 500);
});

$(document).on('click', '.reply_toggle', function () {
    $(this).next('.reply_collapse').toggleClass('hide');
    $(this).find('.fa').toggleClass('fa-angle-down fa-angle-up');
});
$(document).on('click','.more_review_toggle',function(){
    $(this).parent().prev('input.testi_expanded').prop('checked', true);
    $(this).addClass('hide');
});
//End Stamped Reviews
// custom modal
$(document).on('click', '.my_modal_open', function () {
    var my_modal_open = $(this).attr('data-my-modal-open');
    const scrollToTop = "-" + $(document).scrollTop() + "px";
    const scrollToTopDist = $(document).scrollTop() + "px";
    $(my_modal_open).animate({ 'right': '0' }, 'slow').addClass('openedSizeModal');
    $('html,body').addClass('modal-has-opened').attr('data-scrolled', scrollToTopDist);
    $('html,body').css("top", scrollToTop);
});
$(document).on('click', '.my_modal_close', function () {
    var my_modal_close = $(this).attr('data-my-modal-close');
    $(my_modal_close).animate({ 'right': '-100%' }, 'slow').removeClass('openedSizeModal');
    $('html,body').removeClass('modal-has-opened').removeAttr('style');
    var dataScrolled = $('html,body').attr('data-scrolled');
    $('html, body').animate({ scrollTop: dataScrolled }, 10);
    $('html, body').removeAttr('data-scrolled');
});
$(document).click(function (event) {
    if (!$(event.target).closest(".my_modal").length && !$(event.target).closest(".my_modal_open").length) {
        $("body").find(".my_modal").animate({ 'right': '-100%' }, 'slow').removeClass('openedSizeModal');
        $('html,body').removeClass('modal-has-opened').removeAttr('style');
        var dataScrolled = $('html,body').attr('data-scrolled');
        $('html, body').animate({ scrollTop: dataScrolled }, 10);
        $('html, body').removeAttr('data-scrolled');
    }
});
// custom modal
$(document).on('click','.product_current_colour',function(){
    $('html,body').animate({scrollTop: $($(this).data('link')).outerHeight()},'slow');
});

// Predective Search
class PredictiveSearch {
    constructor() {
        this.searchConfig = theme.searchConfig || {};
        this.excludedTitles = this.searchConfig?.titles?.split(',') || [];
        this.excludedTags = this.searchConfig?.tags?.split(',') || [];

        this.viewAllLink = '.total_ac_footer_all';
        this.siteHeaderSearchForm = 'form.site-header__search-form';
        this.searchAutocomplete = '#search-autocomplete';
        this.searchOverlay = '#desktop-search-overlay';
        this.headerPredictiveSearchInput = '#header-predictive-search-input';
        this.predictiveSearchInput = '#predictive-search-input';
        this.searchResPageContainer = $('#search_item_container');
        this.headerAutocomplete = '#header-autocomplete';
        this.searchClearIcon = '.predictive-clear-button';
        this.searchInput = 'input[name="q"]';
    }
    sortElements(a, b) {
        return a.className < b.className;
    }

    filterProducts(productResults) {
        return productResults.filter((el) => {

            const tagsFound = this.excludedTags.length == 1 && this.excludedTags.includes('') ? false : 
            $.grep(el.tags, (e) => {
                return $.inArray(e, this.excludedTags) !== -1;
            }).length;

            const titleFound = this.excludedTitles.length == 1 && this.excludedTitles.includes('') ? false : 
            $.grep(this.excludedTitles, (e) => {
                return el.title.toLowerCase().indexOf(e.toLowerCase()) !== -1;
            }).length;

            return !(titleFound || tagsFound);
        });
    }

    filterPages(pageResults) {
        return pageResults.filter((el) => {
            return !this.searchConfig['pages'].includes(el.handle);
        });
    }

    filterCollections(collectionsResults) {
        return collectionsResults.filter((el) => {
            return !this.searchConfig['collections'].includes(el.handle);
        });
    }

    filterArticles(articlesResults) {
        return articlesResults.filter((el) => {
            return !this.searchConfig['articles'].includes(el.id);
        });
    }
    

    predictiveSearch(inpElem, container) {

        const self = this;
        const query = $(inpElem).val();

        if (!query) {
            return container.empty();
        }

        $.getJSON("/search/suggest.json", {
            "q": query,
            "resources": {
                "limit": 5,
                "options": {
                    "fields": "title,product_type,variants.title,tag"
                }
            }
        }).done((response) => {

            const results = response.resources.results;
            let searchAcHtml = '';

            let productSuggestions = this.filterProducts(results.products || []);
            let pageSuggestions = this.filterPages(results.pages || []);
            let collectionsSuggestions = this.filterCollections(results.collections || []);
            let articlesSuggestions = this.filterArticles(results.articles || []);

            const pageCount = pageSuggestions.length;
            const productsCount = productSuggestions.length;
            const collectionsCount = collectionsSuggestions.length;
            const articlesCount = articlesSuggestions.length;
            const searchType = !productsCount && pageCount && !collectionsCount ? 'page' : 'product';

            $(inpElem).closest('form').find('input[name="type"]').val(searchType);

            if (productsCount || pageCount || collectionsCount || articlesCount) {
                searchAcHtml = `<ul class="search-ac">`;

                if (productsCount) {
                    searchAcHtml += `
                        <li class="product-ac-title search_ac_title_common">
                            <span>PRODUCTS</span>
                        </li>`;
                }

                $(productSuggestions).each((prdAcInd, prdAc) => {
                    const item = prdAc.variants.length > 0 ? prdAc.variants[0] : prdAc;
                    const lastIndPrd = (prdAcInd === productsCount - 1) ? "last-ac" : '';
                    let getComparePrice = 0;
                    let getProductPrice = 0;

                    if (prdAc.price_max != prdAc.price_min && prdAc.variants.length == 0) {
                        getComparePrice = 0;
                    } else {
                        const comapare_key = prdAc.variants.length ? 'compare_at_price' : 'compare_at_price_max';
                        getComparePrice = item[comapare_key] ? item[comapare_key] : 0;
                    }
                
                    if (prdAc.variants.length == 0) {
                        getProductPrice = prdAc.price_max != prdAc.price_min ? prdAc.price_max : prdAc.price;
                    } else {
                        getProductPrice = item.price;
                    }
                
                    let prdPrice = getComparePrice > 0 ? "<span class='product-ac_newprice'>" + moneyFormat(getProductPrice * 100) + "</span><s class='product-ac_compare_price'>" + moneyFormat(getComparePrice * 100) + "</s>" : "<span class='product-ac_price'>" + moneyFormat(getProductPrice * 100) + "</span>";
                    let featuredImage = item.featured_image;
                    let prdImgUrl = featuredImage.url;
                    let prdImage = (prdImgUrl) ? (prdImgUrl.substring(0, prdImgUrl.lastIndexOf('.')) + '_180x.' + prdImgUrl.substring(prdImgUrl.lastIndexOf('.') + 1)) : '';
                    searchAcHtml += "<li class='item-outer " + lastIndPrd + "'><div class='product-ac-container'><a href='" + item.url + "' id='product-ac-" + prdAc.id + "' class='product-ac-main-link' tabindex='-1'><div class='product-ac_suggest product-ac_icon'><div class='product-ac_img_container'><img class='product-ac_img' src='" + prdImage + "' data-widths='[40, 180, 360, 540, 900, 1080]' data-aspectratio='" + featuredImage.aspect_ratio + "' data-sizes='auto' alt='" + featuredImage.alt + "' ></img></div><div class='product-ac_details'><div class='product-ac_name'><span class='prodAcTitle'>" + prdAc.title + "</span></div><div class='product-prices'>" + prdPrice + "</div></div></div></a></div></li>";
                });

                if (collectionsCount > 0) {
                    searchAcHtml += "<li class='collection-ac-title search_ac_title_common'><span>COLLECTIONS</span></li>";
                }
                
                $(collectionsSuggestions).each(function (colAcInd, colAc) {
                    let lastIndColl = (colAcInd === collectionsCount - 1) ? "last-ac" : '';
                    searchAcHtml += "<li class='item-outer " + lastIndColl + "'><div class='collection-ac-container'><a href='" + colAc.url + "' id='collection-ac-" + colAc.id + "' class='item-link' tabindex='-1'>" + colAc.title + "</a></div></li>";
                });
                
                if (pageCount > 0) {
                    searchAcHtml += "<li class='page-ac-title search_ac_title_common'><span>PAGES</span></li>";
                }

                $(pageSuggestions).each(function(pageAcInd, pageAc) {
                    let lastIndPage = (pageAcInd === pageCount - 1) ? "last-ac" : '';
                    searchAcHtml += `<li class="item-outer ${lastIndPage}"><div class="page-ac-container">
                    <a href="${pageAc.url}" id="page-ac-${pageAc.id}" class="page-ac-main-link item-link" tabindex="-1">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="13" viewBox="0 0 12 13" fill="none">
                            <rect y="0.5" width="12" height="12" fill="url(#pattern0)"/>
                            <defs>
                                <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                    <use xlink:href="#image0_383_411" transform="scale(0.03125)"/>
                                </pattern>
                                <image id="image0_383_411" width="32" height="32" xlink:href="data:image/png;base64,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"/>
                            </defs>
                        </svg> ${pageAc.title}
                    </a></div></li>`;
                });

                if (articlesCount > 0) {
                    searchAcHtml += "<li class='article-ac-title search_ac_title_common'><span>BLOG POSTS</span></li>";
                }
                
                $(articlesSuggestions).each(function (i, article) {
                    let lastIndColl = (i === articlesCount - 1) ? "last-ac" : '';
                    searchAcHtml += "<li class='item-outer " + lastIndColl + "'><div class='article-ac-container'><a href='" + article.url + "' id='article-ac-" + article.id + "' class='item-link' tabindex='-1'>" + article.title + "</a></div></li>";
                });
                
                searchAcHtml += `
                <li class="total_ac_cont">
                    <a class="total_ac_footer_all" href="/search?type=product&q=${query}&options[prefix]=last&options[unavailable_products]=last" data-no-instant="">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                        <path d="M6.7987 13.5795C8.31156 13.5795 9.7175 13.0634 10.8565 12.2269L14.6296 16L16.0178 14.6118L12.2448 10.8565C13.0812 9.71746 13.5973 8.32926 13.5973 6.79867C13.5973 3.04338 10.5539 0 6.81646 0C3.07898 0 0 3.06118 0 6.79867C0 10.5362 3.06118 13.5795 6.79867 13.5795L6.7987 13.5795ZM6.7987 1.9577C9.46833 1.9577 11.6218 4.11127 11.6218 6.78084C11.6217 9.45034 9.46827 11.6218 6.7987 11.6218C4.12913 11.6218 1.95776 9.46833 1.95776 6.79863C1.95776 4.12894 4.14683 1.9577 6.7987 1.9577Z" fill="#333333"/>
                        </svg></span> Show all results for: '<b>${query}</b>' <span><svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                        <path d="M0.240882 1.31212L6.92874 7.99998L0.240882 14.6878C0.0472027 14.8833 -0.0274392 15.1673 0.0450345 15.4327C0.117508 15.6981 0.326024 15.9047 0.592189 15.9747C0.858227 16.0446 1.14139 15.9674 1.33507 15.7719L8.57514 8.54201C8.71871 8.39821 8.7994 8.20326 8.7994 8C8.7994 7.79673 8.71871 7.6018 8.57514 7.45799L1.33507 0.228146C1.14139 0.0326412 0.858242 -0.0446241 0.592189 0.0253369C0.326036 0.0952979 0.117523 0.301874 0.0450345 0.567349C-0.0274392 0.832701 0.0472033 1.11666 0.240882 1.31216V1.31212Z" fill="black"/>
                        </svg></span>
                    </a>
                </li>
                </ul>`;
                container.addClass('is-active');
            }

            container.html(searchAcHtml);
        }).fail(() => {
            container.empty();
        });
    }

    initInfiniteScrolling(){
        document.addEventListener("DOMContentLoaded", function() {
            var endlessScroll = new Ajaxinate({
                container: '#searchProducts',
                pagination: '#searchPagination',
                loadingText: '<div class="dot-pulse"></div>'
            });
        });
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    init() {

        const self = this;
        $('#header-autocomplete:not(.is-active)').empty();
        $('<div id="custom-scrollbar"><button class="scrollbar-thumb"></button></div>').insertAfter('.table-scroll');

        $(document).on('click', self.viewAllLink, function (e) {
            e.preventDefault()
            $(this).parents('form').trigger('submit');
        });


        $(document).on('submit', 'form.search-bar,form[role="search"]', function (e) {
            const typeInput = $(this).find('input[name="type"]');
            if (typeInput.val() === 'product') {
                e.preventDefault();
                const formUrl = $(this).attr('action') + '?' + $(this).serialize();
                window.location.href = formUrl;
            }
            if (typeInput.val() === 'page') {
                e.preventDefault();
                const pageSearchUrl = $(self.headerAutocomplete).find('.page-ac-main-link').attr('href') ? $('#header-autocomplete').find('.page-ac-main-link').attr('href') : $(self.searchAutocomplete).find('.page-ac-main-link').attr('href');
                window.location.href = pageSearchUrl;
            }
        });

        $("#searchOverlay-open,#search-icon-fallback").on("click", function (t) {
            t.preventDefault();
            $(self.searchOverlay).show()
            const searchInput = $(self.searchOverlay).find(self.searchInput)
            const end = searchInput.val().length;
            $(self.searchClearIcon).css('visibility',!end ? 'hidden' : 'visible')
            searchInput[0].setSelectionRange(end, end);
            searchInput.trigger('focus')
            $('body,html').addClass('noscroll')
        });

        $(self.searchOverlay).on('click', function (t) {
            const predictiveMobileTopPanel = $(".predictive-mobile-top-panel");
            if (!predictiveMobileTopPanel.is(t.target) && predictiveMobileTopPanel.has(t.target).length === 0) {
                $(this).find(self.searchInput).val('');
                $(`${self.headerAutocomplete},${self.searchAutocomplete}`).empty().removeClass('is-active');
                $('.predictive-ac-results').hide();
                $('body,html').removeClass('noscroll')
            }
        });

        $('body.template-search').on('click', function (t) {
            const SearchForm = $(".SearchForm-SearchPage");
            if (!SearchForm.is(t.target) && SearchForm.has(t.target).length === 0) {
                $(SearchForm).find(self.searchInput).val('');
                $(`${self.searchAutocomplete}`).empty().removeClass('is-active');
            }
        });

        $(`${self.searchOverlay} ${self.searchInput}`).on("keyup", function () {
            const visibility = $(this).val() !== '' ? "visible" : "hidden";
            $(self.searchOverlay).find(self.searchClearIcon).css("visibility", visibility);
        });

        $(`${self.searchOverlay} ${self.searchClearIcon}`).on('click', function (e) {
            e.preventDefault();
            $(self.searchInput).val('')
            $(self.headerPredictiveSearchInput).trigger('focus')
            $(this).css("visibility", "hidden");
            $('.search-ac').empty();
        });


        $(document).on('keyup', self.searchInput, self.debounce((event) => {
            
            const element = event.currentTarget;
            const searchTerm = element.value.trim();

            if (!searchTerm.length) {
                $(`${self.headerAutocomplete},${self.searchAutocomplete}`).empty().removeClass('is-active');
                return;
            }

            const resultSection = $($(element).attr('data-results'))
            self.predictiveSearch(element, resultSection);
        }, 100 ).bind(this));


        $(document).on('beforeinput', self.searchInput, function () {
            if ($(this).val() === '') {
                $($(this).attr('data-results')).empty();
            }
        });

        $(document).on('focus', self.searchInput, function () {
            const resultSectionId = $(this).attr('data-results')
            self.predictiveSearch(this, $(resultSectionId));
        });

        const urlParamsSearch = window.location.search;
        const currentUrl = window.location.href;
        const urlParams = (urlParamsSearch.charAt(urlParamsSearch.length - 1) == '&') ? urlParamsSearch.slice(0, -1) : urlParamsSearch;
        const searchResPageUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + urlParams + "&no_res=1";
        const searchResPageItem = self.searchResPageContainer.find('.grid__item.product__item').length;

        if (currentUrl.indexOf("search?type") > -1) {
            if(currentUrl.indexOf("no_res") === -1 && searchResPageItem == 0){
                window.history.pushState({ path: searchResPageUrl }, '', searchResPageUrl);
            }
            self.initInfiniteScrolling()
        }
    }
}

// Search Initialization
new PredictiveSearch().init() 
// End Search Initialization


//Predective Search End

